<template>
  <!--    经销商列表修改页-->
  <div class="signBox">
    <breadcrumb :routerList="[{to:'/agent/agentCopy',title:'经销商管理'},{title:'经销商详情'}]"/>
    <div class="imgBox width" v-loading="loading">
      <div class="bannerBox">
        <div class="whiteBox">
          <div>
            <div class="h-pieceTitle2" style="margin-bottom: 0.2rem;" v-if="!isShangWei">
              <h1>经销商类型</h1>
            </div>
            <div style="margin: 0.2rem 0 0.2rem 0;" v-if="!isShangWei && guanliren == true">
              <el-radio-group v-model="radio"
                              :disabled="isQuyu == true||$route.query.typeOpr == 'xiuGai'?true:false"
                              @change="changeType">
                <el-radio-button label="国内客户"></el-radio-button>
                <!--                                <el-radio-button label="上海直销"></el-radio-button>-->
                <el-radio-button label="海外客户"></el-radio-button>
              </el-radio-group>
            </div>
            <div style="margin: 0.2rem 0 0.2rem 0;" v-if="!isShangWei && guanliren == false && haiwairen == false">
              <el-radio-group v-model="radio"
                              :disabled="isQuyu == true ||this.$route.query.typeOpr == 'xiuGai'?true:false"
                              @change="changeType">
                <el-radio-button label="国内客户"></el-radio-button>
                <el-radio-button label="上海直销"></el-radio-button>
              </el-radio-group>
            </div>
            <div style="margin: 0.2rem 0 0.2rem 0;" v-if="!isShangWei && guanliren == false && haiwairen == true">
              <el-radio-group v-model="radio"
                              :disabled="isQuyu == true"
                              @change="changeType">
                <el-radio-button label="海外客户"></el-radio-button>
              </el-radio-group>
            </div>
            <div class="h-pieceTitle2" style="margin-bottom: 0.2rem;" v-if="!isShangWei">
              <h1>直单类型（客户性质）</h1>
            </div>
            <div style="margin-top: 0.3rem;margin-bottom: 0.2rem;" v-if="!isShangWei">
              <div style="font-size: 0.15rem;color: #ff2424;margin-bottom: 0.2rem">*
                如果您是直单用户，请勾选下方按钮，如果不是请不要勾选！
              </div>
              <el-switch
                  @change="chooseZhiDan"
                  v-model="isZhiDan"
                  class="zhidangc"
                  active-text="是否是直单用户"
                  inactive-text="">
              </el-switch>
              <el-switch
                  :disabled="isQuyu == true"
                  style="margin-left: 50px;"
                  v-if="this.isZhiDan == true && this.agentType != '3'"
                  class="zhidangc"
                  @change="chooseGoverment"
                  v-model="isGoverment"
                  active-text="是否是政府企业/军工企业"
                  inactive-text="">
              </el-switch>
              <!-- v-if="this.data.isExpandAuthorityBas == '1'" -->
              <span  v-if="this.agentType != '3'">
                                <el-switch
                                    style="margin-left: 50px"
                                    v-model="isExpandAuthority"
                                    @change="chooseAddAbroad"
                                    active-text="是否开通海外下单权限"
                                    :disabled="isQuyu == true">
                                </el-switch>
                            </span>
              <!--                            <span v-else>
                                <el-switch
                                        style="margin-left: 50px;"
                                        v-model="isExpandAuthority"
                                        @change="chooseDomestic"
                                        active-text="是否开通国内下单权限"
                                        :disabled="isQuyu == true">
                                </el-switch>
                            </span>-->
            </div>

            <el-collapse v-model="activeNames">
              <el-collapse-item name="1" v-if="!isShangWei">
                <template slot="title">
                  <div style="display: flex;align-items: center" @click.stop>
                    <span class="collapseTitle" style="color:#0e75e9">客户资质信息</span>
                  </div>
                </template>
                <div class="signsign">
                    <el-form v-if="!isShangWei" :model="formLabelAlign1.bscUserInfoAgentBasic" label-position="right"
                             ref="formLabelAlign1c"
                             :inline="true" :rules="rules1" class="demo-ruleForm h-formbLine h-formbLine1">
                      <el-form-item label="公司名称" class="h-elformWrap-2" prop="customerName1">
                        <el-input placeholder="请填写完整的公司全称" :readonly="isQuyu == true"
                                  :title="formLabelAlign1.bscUserInfoAgentBasic.customerName1"
                                  v-model="formLabelAlign1.bscUserInfoAgentBasic.customerName1"></el-input>
                      </el-form-item>
                      <el-form-item label="客户编码" class="h-elformWrap-2" prop="usercode">
                        <el-input readonly
                                  v-model="formLabelAlign1.bscUserInfoAgentBasic.usercode"
                                  placeholder=""></el-input>
                      </el-form-item>
                      <el-form-item label="客户" v-if="this.agentType != '3'||agentType==3&&isExpandAuthority?true:false" class="h-elformWrap-2" prop="scale">
                        <el-select
                            :disabled="isQuyu == true"
                            v-model="formLabelAlign1.bscUserInfoAgentBasic.scale"
                            placeholder="请选择">
                          <el-option label="小规模经营者" value="0"></el-option>
                          <el-option label="一般纳税人" value="1"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="公司地址" class="h-elformWrap-2" prop="companyAddress">
                        <el-input
                            :readonly="isQuyu == true"
                            :title="formLabelAlign1.bscUserInfoAgentBasic.companyAddress"
                            v-model="formLabelAlign1.bscUserInfoAgentBasic.companyAddress"
                            placeholder="请填写详细的公司地址"></el-input>
                      </el-form-item>
                      <el-form-item label="公司邮箱" class="h-elformWrap-2" prop="email">
                        <el-input
                            :readonly="isQuyu == true"
                            v-model="formLabelAlign1.bscUserInfoAgentBasic.email"
                            :placeholder="this.flag==='2'||this.flag==='3'||this.flag==='4' ? '' : '请填写' "></el-input>
                      </el-form-item>
                      <el-form-item label="公司性质" v-if="this.agentType != '3'||agentType==3&&isExpandAuthority?true:false" class="h-elformWrap-2" prop="companytype">
                        <el-input
                            :readonly="isQuyu == true"
                            v-model="formLabelAlign1.bscUserInfoAgentBasic.companytype"
                            placeholder="请填写"></el-input>
                      </el-form-item>

                      <!--   新增开始-->

                      <el-form-item label="成立时间" class="h-elformWrap-2" prop="founded" v-if="this.agentType != '3'||agentType==3&&isExpandAuthority?true:false">
                        <el-date-picker
                            :disabled="isQuyu"
                            v-model="formLabelAlign1.bscUserInfoAgentBasic.founded"
                            type="date"
                            :class="{'ljjSelectdisabled':this.flag==='2'||this.flag==='3'||this.flag==='4'}"
                            :placeholder="this.flag==='2'||this.flag==='3'||this.flag==='4'?'':'选择日期'"
                        >
                        </el-date-picker>
                      </el-form-item>
                      <el-form-item label="总经理姓名" class="h-elformWrap-2" prop="legal" v-if="this.agentType != '3'||agentType==3&&isExpandAuthority?true:false">
                        <el-input :readonly="isQuyu"
                                  v-model="formLabelAlign1.bscUserInfoAgentBasic.legal"
                                  :placeholder="this.flag==='2'||this.flag==='3'||this.flag==='4'?'':'请填写'"
                        ></el-input>
                      </el-form-item>
                      <el-form-item label="年度营业规模(万元)" class="h-elformWrap-2" prop="achievement" v-if="this.agentType != '3'||agentType==3&&isExpandAuthority?true:false">
                        <el-input :readonly="isQuyu"
                                  v-model="formLabelAlign1.bscUserInfoAgentBasic.achievement"
                                  :placeholder="this.flag==='2'||this.flag==='3'||this.flag==='4'?'':'请填写'"
                        ></el-input>
                      </el-form-item>

                      <el-form-item label="销售人员数量" class="h-elformWrap-2" prop="legal" v-if="this.agentType != '3'||agentType==3&&isExpandAuthority?true:false">
                        <el-input :readonly="isQuyu"
                                  v-model="formLabelAlign1.bscUserInfoAgentBasic.personnelNum"
                                  :placeholder="this.flag==='2'||this.flag==='3'||this.flag==='4'?'':'请填写'"
                        ></el-input>
                      </el-form-item>
                      <el-form-item label="总经理联系方式" class="h-elformWrap-2" prop="legal" v-if="this.agentType != '3'||agentType==3&&isExpandAuthority?true:false">
                        <el-input :readonly="isQuyu"
                                  v-model="formLabelAlign1.bscUserInfoAgentBasic.legalPhone"
                                  :placeholder="this.flag==='2'||this.flag==='3'||this.flag==='4'?'':'请填写'"
                        ></el-input>
                      </el-form-item>
                      <el-form-item label="经营其他品牌" class="h-elformWrap-2" prop="legal" v-if="this.agentType != '3'||agentType==3&&isExpandAuthority?true:false">
                        <el-input :readonly="isQuyu"
                                  v-model="formLabelAlign1.bscUserInfoAgentBasic.brand"
                                  :placeholder="this.flag==='2'||this.flag==='3'||this.flag==='4'?'':'请填写'"
                        ></el-input>
                      </el-form-item>
                      <!--   新增结束-->

                      <el-form-item label="联系人" class="h-elformWrap-2" prop="name1">
                        <el-input
                            :readonly="isQuyu == true"
                            v-model="formLabelAlign1.bscUserInfoAgentBasic.name1"
                            placeholder="请填写"></el-input>
                      </el-form-item>
                      <el-form-item label="联系人手机号" class="h-elformWrap-2" prop="contactMobilePhone">
                        <el-input
                            :readonly="isQuyu == true"
                            v-model="formLabelAlign1.bscUserInfoAgentBasic.contactMobilePhone"
                            placeholder="请填写"></el-input>
                      </el-form-item>
                      <el-form-item label="所在国家" class="h-elformWrap-2" prop="country">
                        <brselectlazy category="YLCountry_agent"
                                      :v="formLabelAlign1.bscUserInfoAgentBasic.country"
                                      v-model="formLabelAlign1.bscUserInfoAgentBasic.country"
                                      :clearable="true"
                                      :disabled="isQuyu == true"/>
                      </el-form-item>
                      <el-form-item label="所在地区" class="h-elformWrap-2" prop="region"
                                    v-if="this.agentType != '3'||agentType==3&&isExpandAuthority?true:false">
                        <brselectlazy category="YLRegion"
                                      :v="formLabelAlign1.bscUserInfoAgentBasic.region"
                                      v-model="formLabelAlign1.bscUserInfoAgentBasic.region"
                                      :clearable="true"
                                      :disabled="isQuyu == true"/>
                      </el-form-item>
                      <el-form-item label="所在城市" class="h-elformWrap-2" prop="companyAddress"
                                    v-if="this.agentType != '3'||agentType==3&&isExpandAuthority?true:false">
                        <el-select
                            filterable
                            v-model="formLabelAlign1.bscUserInfoAgentBasic.contactCity"
                            @change="changeFlag"
                            placeholder="请选择">
                          <el-option v-for="(item,index) in addli" :key="index" :label="item" :value="item">
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="关联公司" class="h-elformWrap-2" prop="associatedCompanyName" v-if="this.flag==='3'|| this.radio == '海外客户' || this.isExpandAuthority == '1'">
                        <el-select v-model="formLabelAlign1.bscUserInfoAgentBasic.associatedCompanyName"
                                   :title="formLabelAlign1.bscUserInfoAgentBasic.associatedCompanyName"
                                   remote filterable
                                   :readonly="this.flag==='3'|| this.radio == '海外客户' || this.isExpandAuthority == '1'"
                                   :filter-method="showAssociationAgent" clearable  placeholder="请输入"
                                   :remote-method="showAssociationAgent" @change="changeAssociationAgent($event)" >
                          <el-option v-for="(item) in associatedCompanyList"
                                     :key="item.username"
                                     :label="item.username"
                                     :value="item">
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="关联公司编码" class="h-elformWrap-2" prop="associatedCompanyCode" v-if="this.flag==='3'|| this.radio == '海外客户' || this.isExpandAuthority == '1'">
                        <el-input :readonly="this.flag==='3' || this.radio == '海外客户' || this.isExpandAuthority == '1'"
                                  v-model="formLabelAlign1.bscUserInfoAgentBasic.associatedCompanyCode"
                                  disabled></el-input>
                      </el-form-item>
                      <el-form-item label="备注" v-if="this.agentType == '3'" class="h-elformWrap-2">
                        <el-input :readonly="isQuyu == true"
                                  v-model="formLabelAlign1.bscUserInfoAgentBasic.remark"
                                  :placeholder="this.flag==='2'||this.flag==='3'||this.flag==='4'?'':'请填写'"
                                  :clearable="true"></el-input>
                      </el-form-item>
                      <!-- <el-form-item label="是否国内贸易公司" v-if="this.agentType == '3'" class="h-elformWrap-2" prop="isTrade">
                                            <brselectlazy category="shifou_keyong"
                                                        :v="formLabelAlign1.bscUserInfoAgentBasic.isTrade"
                                                        v-model="formLabelAlign1.bscUserInfoAgentBasic.isTrade"
                                                        :clearable="true"/>
                                        </el-form-item> -->
                      <!-- <el-form-item label="备注" v-if="this.agentType == '3'" class="h-elformWrap-2">
                                            <el-input :readonly="this.flag==='2'||this.flag==='3'||this.flag==='4'"
                                                    v-model="formLabelAlign1.bscUserInfoAgentBasic.remark"
                                                    placeholder="请填写" :clearable="true"></el-input>
                                        </el-form-item> -->
                    </el-form>
                </div>
              </el-collapse-item>
              <el-collapse-item name="2">
                <template slot="title">
                  <div style="display: flex;align-items: center" @click.stop>
                    <span class="collapseTitle" style="color:#0e75e9">开票信息</span>
                    <span style="font-size: 14px;color: #a8a8a8;margin-left:19px;font-weight: normal;">凡是贵公司相关信息的变更请及时通知，以便及时调整，保证开票信息无误</span>
                  </div>
                </template>
                <div class="signsign">
                  <el-form :model="formLabelAlign1.bscUserInfoAgentBasic" label-position="right"
                           ref="formLabelAlign1d"
                           :inline="true" :rules="rules1" class="demo-ruleForm h-formbLine h-formbLine1">
                    <el-form-item label="客户名称" class="h-elformWrap-2" prop='customerName1' v-if="this.agentType != 3||agentType==3&&isExpandAuthority?true:false">
                      <el-input
                          readonly
                          :title="formLabelAlign1.bscUserInfoAgentBasic.customerName1"
                          v-model="formLabelAlign1.bscUserInfoAgentBasic.customerName1"
                          placeholder="请填写"></el-input>
                    </el-form-item>
                    <el-form-item label="开票电话" class="h-elformWrap-2" prop='phoneNumber'
                                  :class="{'gccolor':phoneNumber}">
                      <el-input
                          :readonly="isQuyu == true"
                          v-model="formLabelAlign1.bscUserInfoAgentBasic.phoneNumber"
                          placeholder="请填写"></el-input>
                    </el-form-item>
                    <el-form-item label="开票地址" class="h-elformWrap-2" prop="cityStreetRoom"
                                  :class="{'gccolor':cityStreetRoom}">
                      <el-input clearable
                                :readonly="isQuyu == true"
                                maxlength = "86"
                                :title="formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom"
                                v-model="formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom">
                      </el-input>
                    </el-form-item>
                    <!--                                    <el-form-item label="纳税人登记号" class="h-elformWrap-2" prop="taxCode"-->
                    <!--                                                  :class="{'gccolor':taxCode}" v-show="formLabelAlign1.bscUserInfoAgentBasic.isTrade == 1 || this.agentType == '1'">-->
                    <!--                                        <el-input-->
                    <!--                                                :readonly="isQuyu == true"-->
                    <!--                                                v-model="formLabelAlign1.bscUserInfoAgentBasic.taxCode" maxlength="18"-->
                    <!--                                                show-word-limit-->
                    <!--                                                style="width: 3rem;"-->
                    <!--                                                placeholder="请填写"></el-input>-->
                    <!--                                    </el-form-item>-->
                    <el-form-item label="纳税人登记号" class="h-elformWrap-2"
                                  :class="{'gccolor':taxCode}" v-if="">
                      <el-input
                          :readonly="isQuyu == true"
                          v-model="formLabelAlign1.bscUserInfoAgentBasic.taxCode"
                          placeholder="请填写"></el-input>
                    </el-form-item>
                  </el-form>
                  <el-form :model="formLabelAlign1.bscUserInfoAgentBank" label-position="right"
                           ref="formLabelAlign1e"
                           :inline="true" :rules="rules1" class="demo-ruleForm h-formbLine h-formbLine1" v-if="">

                    <el-form-item
                        :class="{'gccolor':bankBranchCode}"
                        label="银行编号"
                        class="h-elformWrap-2"
                        prop="bankBranchCode" v-show="formLabelAlign1.bscUserInfoAgentBasic.isTrade == 1 || this.agentType == '1' || this.agentType == '2'">
                      <el-input
                          :readonly="isQuyu == true"
                          v-model="formLabelAlign1.bscUserInfoAgentBank.bankBranchCode"
                          placeholder="请填写"></el-input>
                    </el-form-item>
                    <el-form-item
                        :class="{'gccolor':bankBranchCode}"
                        label="银行编号"
                        class="h-elformWrap-2"
                        v-show="formLabelAlign1.bscUserInfoAgentBasic.isTrade != 1 && this.agentType == '3'">
                      <el-input
                          :readonly="isQuyu == true"
                          v-model="formLabelAlign1.bscUserInfoAgentBank.bankBranchCode"
                          placeholder="请填写"></el-input>
                    </el-form-item>
                    <el-form-item
                        :class="{'gccolor':bankName}"
                        label="银行名称"
                        class="h-elformWrap-2"
                        prop="bankName"
                        v-show="formLabelAlign1.bscUserInfoAgentBasic.isTrade == 1 || this.agentType == '1' || this.agentType == '2'">
                      <el-input
                          :readonly="isQuyu == true"
                          :title="formLabelAlign1.bscUserInfoAgentBank.bankName"
                          v-model="formLabelAlign1.bscUserInfoAgentBank.bankName"
                          placeholder="请填写"></el-input>
                    </el-form-item>
                    <el-form-item
                        :class="{'gccolor':bankName}"
                        label="银行名称"
                        class="h-elformWrap-2"
                        v-show="formLabelAlign1.bscUserInfoAgentBasic.isTrade != 1 && this.agentType == '3'">
                      <el-input
                          :readonly="isQuyu == true"
                          :title="formLabelAlign1.bscUserInfoAgentBank.bankName"
                          v-model="formLabelAlign1.bscUserInfoAgentBank.bankName"
                          placeholder="请填写"></el-input>
                    </el-form-item>
                    <el-form-item label="银行账户号" class="h-elformWrap-2" prop="accountHolderName"
                                  :class="{'gccolor':accountHolderName}" v-show="formLabelAlign1.bscUserInfoAgentBasic.isTrade == 1 || this.agentType == '1' || this.agentType == '2'">
                      <el-input
                          :readonly="isQuyu == true"
                          v-model="formLabelAlign1.bscUserInfoAgentBank.accountHolderName"
                          onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                          placeholder="请填写"></el-input>
                    </el-form-item>
                    <el-form-item label="银行账户号" class="h-elformWrap-2"
                                  :class="{'gccolor':accountHolderName}" v-show="formLabelAlign1.bscUserInfoAgentBasic.isTrade != 1 && this.agentType == '3'">
                      <el-input
                          :readonly="isQuyu == true"
                          v-model="formLabelAlign1.bscUserInfoAgentBank.accountHolderName"
                          onkeyup="value=value.replace(/[^\a-z\A-\Z0-9\ ]/g,'')"
                          placeholder="请填写"></el-input>
                    </el-form-item>
                    <el-form-item label="银行所属国家" class="h-elformWrap-2" prop="bankCountry"
                                  :class="{'gccolor':bankCountry}" v-show="formLabelAlign1.bscUserInfoAgentBasic.isTrade == 1 || this.agentType == '1' || this.agentType == '2'">
                      <brselectlazy category="YLCountry_agent"
                                    :v="formLabelAlign1.bscUserInfoAgentBank.bankCountry"
                                    v-model="formLabelAlign1.bscUserInfoAgentBank.bankCountry"
                                    :clearable="true"
                                    :disabled="isQuyu == true"/>
                    </el-form-item>
                    <el-form-item label="银行所属国家" class="h-elformWrap-2"
                                  :class="{'gccolor':bankCountry}" v-show="formLabelAlign1.bscUserInfoAgentBasic.isTrade != 1 && this.agentType == '3'">
                      <brselectlazy category="YLCountry_agent"
                                    :v="formLabelAlign1.bscUserInfoAgentBank.bankCountry"
                                    v-model="formLabelAlign1.bscUserInfoAgentBank.bankCountry"
                                    :clearable="true"
                                    :disabled="isQuyu == true"/>
                    </el-form-item>
                  </el-form>
                  <el-form :model="formLabelAlign1.bscUserInfoAgentSell" label-position="right"
                           ref="formLabelAlign1f"
                           :inline="true" :rules="rules1" class="demo-ruleForm h-formbLine h-formbLine1">
                    <el-form-item label="发票类型" class="h-elformWrap-2" prop="customerGroup1"
                                  v-if=""
                                  :class="{'gccolor':customerGroup1}">
                      <el-select
                          :disabled="isQuyu == true"
                          placeholder="请选择"
                          v-model="formLabelAlign1.bscUserInfoAgentSell.customerGroup1">
                        <el-option label="增值税发票" value="01"></el-option>
                        <el-option label="普通发票" value="02"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="国际贸易条件" class="h-elformWrap-2" prop="intCommercialTerms"
                                  v-if="!isShowMassage || this.radio == '海外客户' || this.isExpandAuthority ==1">
                      <brselectlazy category="YlCommercialTerms" :showcode="true"
                                    :v="formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms"
                                    v-model="formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms"
                                    :clearable="true"
                      />
                    </el-form-item>
                    <el-form-item label="国际贸易条件2" class="h-elformWrap-2" prop="intCommercialTerms2"
                                  v-if="!isShowMassage || this.radio == '海外客户' || this.isExpandAuthority == 1">
                      <brselectlazy category="YlCommercialTerms" :showcode="true"
                                    :v="formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms2"
                                    v-model="formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms2"
                                    :clearable="true"
                      />
                    </el-form-item>
                    <!-- v-if="this.agentType == 3 || this.isExpandAuthority" -->
                    <el-form-item label="货币种类"  class="h-elformWrap-2" prop="currencyCode">
                      <brselectlazy category="YLCurrency" :disabled="isQuyu == true" :v="formLabelAlign1.bscUserInfoAgentSell.currencyCode"
                                    v-model="formLabelAlign1.bscUserInfoAgentSell.currencyCode" :clearable="true"/>
                    </el-form-item>
                    <el-form-item label="电票邮箱" class="h-elformWrap-2" prop='inEmail'
                                  :class="{'gccolor':phoneNumber}">
                      <el-input
                          :readonly="isQuyu == true"
                          v-model="formLabelAlign1.bscUserInfoAgentSell.inEmail"
                          placeholder="请填写"></el-input>
                    </el-form-item>

                    <div class="h-formLine Yangbiao">
                      <el-form-item label="开票信息" class="h-elformWrap-3" prop="invInformation"
                                    v-if="!isShowMassage || this.radio == '海外客户' || this.isExpandAuthority == '1'">
                        <el-input :readonly="isQuyu == true"
                                  type="textarea"
                                  :rows="4"
                                  v-model="formLabelAlign1.bscUserInfoAgentSell.invInformation"
                                  show-word-limit
                                  maxlength="500">
                        </el-input>
                      </el-form-item>
                    </div>

                  </el-form>
                </div>
              </el-collapse-item>
              <!--邮寄发票信息暂时注释-->
<!--              <el-collapse-item name="3"  v-if="!isShangWei&&agentType!=3||agentType==3&&isExpandAuthority?true:false">-->
<!--                <template slot="title">-->
<!--                  <div style="display: flex;align-items: center" @click.stop>-->
<!--                    <span class="collapseTitle" style="color:#0e75e9">邮寄发票信息</span>-->
<!--                  </div>-->
<!--                </template>-->
<!--                <div class="signsign">-->
<!--                  <el-form :model="formLabelAlign1.bscUserInfoAgentCompany" label-position="right"-->
<!--                           ref="formLabelAlign1h"-->
<!--                           :inline="true" :rules="rules1" class="demo-ruleForm h-formbLine h-formbLine1">-->
<!--                    <el-form-item label="邮寄接收人" class="h-elformWrap-2" prop="mailreceiver">-->
<!--                      <el-input-->
<!--                          :readonly="isQuyu == true"-->
<!--                          v-model="formLabelAlign1.bscUserInfoAgentCompany.mailreceiver"-->
<!--                          placeholder="请填写"></el-input>-->
<!--                    </el-form-item>-->
<!--                    <el-form-item label="电话" class="h-elformWrap-2" prop="receiverphone">-->
<!--                      <el-input-->
<!--                          :readonly="isQuyu == true"-->
<!--                          v-model="formLabelAlign1.bscUserInfoAgen tCompany.receiverphone"-->
<!--                          placeholder="请填写"></el-input>-->
<!--                    </el-form-item>-->
<!--                    &lt;!&ndash;                                    <el-form-item label="邮寄地址" class="h-elformWrap-2" prop="mailaddress">&ndash;&gt;-->
<!--                    &lt;!&ndash;                                        <el-input  v-model="formLabelAlign1.bscUserInfoAgentCompany.mailaddress"&ndash;&gt;-->
<!--                    &lt;!&ndash;                                                  placeholder="请填写"></el-input>&ndash;&gt;-->
<!--                    <el-form-item label="选择邮寄地址" class="h-elformWrap-2" prop="mailaddress">-->
<!--                      <el-input clearable-->
<!--                                :readonly="isQuyu == true"-->
<!--                                :title="formLabelAlign1.bscUserInfoAgentCompany.mailaddress"-->
<!--                                v-model="formLabelAlign1.bscUserInfoAgentCompany.mailaddress">-->
<!--                        <i-->
<!--                            v-show="this.flag!=='2'&&this.flag!=='3'&&this.flag!=='4'"-->
<!--                            class="el-icon-edit el-input__icon"-->
<!--                            slot="suffix"-->
<!--                            @click="handleIconClick">-->
<!--                        </i>-->
<!--                      </el-input>-->
<!--                    </el-form-item>-->
<!--                  </el-form>-->
<!--                </div>-->
<!--              </el-collapse-item>-->
              <el-collapse-item name="4" v-if="!isShangWei">
                <template slot="title">
                  <div style="display: flex;align-items: center" @click.stop>
                    <span class="collapseTitle" style="color:#0e75e9">上传附件</span>
                  </div>
                </template>
                <div class="h-formLine weekplandetail12">
                  <el-form :model="formLabelAlign1.bscUserInfoAgentBasic" label-position="right"
                           ref="formLabelAlign1i"
                           :inline="true" :rules="rules1" class="demo-ruleForm h-formbLine h-formbLine1">
                    <el-form-item label="委托汇款的附件" class="h-elformWrap-2" prop="upload7"
                                  v-if="have2 && (this.agentType == '3'||agentType != 3 && isExpandAuthority)">
                      <brupload
                          v-model="formLabelAlign1.bscUserInfoAgentBasic.upload5"
                          v-if="fileShowFlag"
                          :refid="refid"
                          reftype="代理商注册-委托汇款的附件"
                          :uploadflag="isQuyu == false"
                          :delflag="isQuyu == false"
                          @filecallback="fileBack1"
                          :showtime="false">
                      </brupload>
                    </el-form-item>
                    <el-form-item label="企业营业执照" class="h-elformWrap-2" prop="upload"
                                  v-if="this.agentType != '3' || (this.agentType == '3' && this.isExpandAuthority == true)">
                      <brupload
                          v-if="fileShowFlag"
                          :refid="refid"
                          reftype="代理商注册-企业营业执照"
                          :uploadflag="isQuyu == false"
                          :delflag="isQuyu == false"
                          :showtime="false"
                      >
                      </brupload>
                    </el-form-item>
                    <el-form-item label="企业营业执照有效截止日期" class="h-elformWrap-2" prop="yyzzEffectiveDate"
                                  v-if="this.agentType != '3' || (this.agentType == '3' && this.isExpandAuthority == true)">
                      <el-date-picker
                          style="width: 180px"  v-if="fileShowFlag"
                          v-model="formLabelAlign1.bscUserInfoAgentSell.yyzzEffectiveDate"
                          type="date"
                          :disabled="isQuyu == true"
                          placeholder="选择日期">
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item label="银行开户证明" class="h-elformWrap-2" prop="upload"
                                  v-if="this.agentType != '3' || (this.agentType == '3' && this.isExpandAuthority == true)">
                      <brupload
                          v-if="fileShowFlag"
                          :refid="refid"
                          reftype="代理商注册-银行开户证明"
                          :uploadflag="isQuyu == false"
                          :delflag="isQuyu == false"
                          :showtime="false"
                      >
                      </brupload>
                    </el-form-item>
                    <el-form-item label="法人身份证" class="h-elformWrap-2" prop="upload"
                                  v-if="this.agentType != '3' || (this.agentType == '3' && this.isExpandAuthority == true)">
                      <brupload
                          v-if="fileShowFlag"
                          :refid="refid"
                          :tpFlag = 'true'
                          :isTpAndPdf = 'true'
                          reftype="代理商注册-法人身份证"
                          :uploadflag="isQuyu == false"
                          :delflag="isQuyu == false"
                          :showtime="false"
                      >
                      </brupload>
                    </el-form-item>
                    <el-form-item label="一般纳税人提供相关资质证明" class="h-elformWrap-2" prop="upload"
                                  v-if="this.agentType != '3' || (this.agentType == '3' && this.isExpandAuthority == true)">
                      <brupload
                          v-if="fileShowFlag"
                          :refid="refid"
                          reftype="代理商注册-一般纳税人提供相关资质证明"
                          :uploadflag="isQuyu == false"
                          :delflag="isQuyu == false"
                          :showtime="false"
                      >
                      </brupload>
                    </el-form-item>
                    <el-form-item label="名称修改见证性资料" class="h-elformWrap-2" prop="upload"
                                  v-if="this.agentType != '3' || (this.agentType == '3' && this.isExpandAuthority == true)">
                      <brupload
                          :refid="refid"
                          reftype="代理商修改名称-见证性资料"
                          :uploadflag="isQuyu == false"
                          :delflag="isQuyu == false"
                          :showtime="false">
                      </brupload>
                    </el-form-item>
                    <el-form-item label="发票类型见证性资料" class="h-elformWrap-2" prop="upload"
                                  v-if="this.agentType != '3' || (this.agentType == '3' && this.isExpandAuthority == true)">
                      <brupload
                          :refid="refid"
                          reftype="代理商修改发票-见证性资料"
                          :uploadflag="isQuyu == false"
                          :delflag="isQuyu == false"
                          :showtime="false">
                      </brupload>
                    </el-form-item>
                    <!--<div style="margin-left:2.1rem;margin-bottom: 0.5rem;">
                                                            <el-switch

                                                                    v-model="have2"
                                                                    active-text=""
                                                                    inactive-text="是否有备案表">
                                                            </el-switch>
                    </div>-->
                    <el-form-item label="备案表" class="h-elformWrap-2" prop="upload5"
                                  v-if="have2 && (this.agentType != '3' || (this.agentType == '3' && this.isExpandAuthority == true))">
                      <brupload
                          v-model="formLabelAlign1.bscUserInfoAgentBasic.upload5"
                          v-if="fileShowFlag"
                          :refid="refid"
                          reftype="代理商注册-二类经营许可证"
                          :uploadflag="isQuyu == false"
                          :delflag="isQuyu == false"
                          @filecallback="fileBack1"
                          :showtime="false"
                      >
                      </brupload>
                    </el-form-item>
                    <el-form-item style="padding-right:0;width: 100%!important;" label="" class="HAVES-2 h-elformWrap-2"
                                  v-if="have2 && (this.agentType != '3' || (this.agentType == '3' && this.isExpandAuthority == true))">
                      <el-switch
                          :disabled="isQuyu"
                          style="margin-left: 0.4rem;"
                          @change="choose2017"
                          v-model="havepolicy2017"
                          active-text=""
                          inactive-text="是否包含2017版分类目录">
                      </el-switch>
                      <el-switch
                          :disabled="isQuyu"
                          style="margin-left: 0.4rem;"
                          v-model="have1101"
                          v-if="this.formLabelAlign1.bscUserInfoAgentSell.havepolicy2017 == 1"
                          active-text=""
                          inactive-text="是否包含11-01">
                      </el-switch>
                      <el-switch
                          :disabled="isQuyu"
                          style="margin-left: 0.4rem;"
                          v-model="have2214"
                          v-if="this.formLabelAlign1.bscUserInfoAgentSell.havepolicy2017 == 1"
                          active-text=""
                          inactive-text="是否包含22-14">
                      </el-switch>
                      <el-switch
                          :disabled="isQuyu == true"
                          style="margin-left: 0.4rem;"
                          v-model="have2215"
                          v-if="this.formLabelAlign1.bscUserInfoAgentSell.havepolicy2017 == 1"
                          active-text=""
                          inactive-text="是否包含22-15">
                      </el-switch>
                      <el-switch
                          :disabled="isQuyu == true"
                          style="margin-left: 0.4rem;"
                          v-model="have2216"
                          v-if="this.formLabelAlign1.bscUserInfoAgentSell.havepolicy2017 == 1"
                          active-text=""
                          inactive-text="是否包含22-16">
                      </el-switch>
                    </el-form-item>
                    <el-form-item style="padding-right:0;width: 50%!important;" label="" class="HAVES-2 h-elformWrap-2"
                                  v-if="have2 && (this.agentType != '3' || (this.agentType == '3' && this.isExpandAuthority == true))">
                      <el-switch
                          style="margin-left: 0.4rem;"
                          v-model="have6858"
                          :disabled="isQuyu == true"
                          @change="changeFlag"
                          active-text=""
                          inactive-text="是否包含6858">
                      </el-switch>
                      <el-switch
                          style="margin-left: 0.5rem;"
                          v-model="have6840"
                          :disabled="isQuyu == true"
                          @change="changeFlag"
                          active-text=""
                          inactive-text="是否包含6840">
                      </el-switch>
                      <el-switch
                          style="margin-left: 0.5rem;"
                          v-if="(this.agentType != '3' || (this.agentType == '3' && this.isExpandAuthority == true))"
                          v-model="have6854"
                          :disabled="isQuyu == true"
                          @change="changeFlag"
                          active-text=""
                          inactive-text="是否包含6854">
                      </el-switch>
                    </el-form-item>
                    <el-form-item class="h-elformWrap-5" >
                      <el-switch
                          style="margin-left: 0.2rem;"
                          v-model="have3"
                          :disabled="isQuyu == true"
                          @change="changeFlag"
                          active-text=""
                          inactive-text="是否有许可证">
                      </el-switch>
                      <el-switch
                          style="margin-left: 0.4rem;"
                          v-if="(this.agentType != '3' || (this.agentType == '3' && this.isExpandAuthority == true))"
                          @change="chooseIVD"
                          :disabled="isQuyu == true"
                          v-model="haveThree6840"
                          inactive-text="是否包含III类6840(体外诊断试剂)">
                      </el-switch>
                    </el-form-item>
                    <el-form-item label="许可证" class="h-elformWrap-2" prop="upload6"
                                  v-if="have3 && (this.agentType != '3' || (this.agentType == '3' && this.isExpandAuthority == true))">
                      <div style="display: flex;align-items: center;">
                        <brupload
                            v-model="formLabelAlign1.bscUserInfoAgentBasic.upload6"
                            v-if="fileShowFlag"
                            :refid="refid"
                            reftype="代理商注册-三类经营许可证"
                            :uploadflag="isQuyu == false"
                            :delflag="isQuyu == false"
                            :showtime="false"
                            @filecallback="fileBack2"
                            style="width: 3rem;"
                        >
                        </brupload>
                      </div>
                    </el-form-item>
                    <el-form-item label="许可证有效截止日期" class="h-elformWrap-2" prop="xkzEffectiveDate"
                                  v-show="have3 && (this.agentType != '3' || (this.agentType == '3' && this.isExpandAuthority == true))">
                      <el-date-picker
                          style="width: 180px"
                          v-model="formLabelAlign1.bscUserInfoAgentSell.xkzEffectiveDate"
                          type="date"
                          :disabled="isQuyu == true"
                          placeholder="选择日期">
                      </el-date-picker>
                    </el-form-item>
                    <!--  补充  包含III类6840(体外诊断试剂 -->
                    <el-form-item label="三类经营许可证"   class="h-elformWrap-2" v-if="this.haveThree6840 == 1"
                                  :prop="formLabelAlign1.bscUserInfoAgentSell.haveThree6840 == true? 'upload8': '' ">
                      <brupload
                          v-model="formLabelAlign1.bscUserInfoAgentBasic.upload8"
                          v-if="fileShowFlag"
                          :refid="refid"
                          reftype="三类6840经营许可证"
                          :uploadflag="isQuyu == false"
                          :delflag="isQuyu == false"
                          :showtime="false"
                          @filecallback="fileBack3"
                          style="width: 3rem;">
                      </brupload>

                    </el-form-item>
                  </el-form>
                  <el-form :model="formLabelAlign1.bscUserInfoAgentSell"
                           ref="formLabelAlign1i"
                           :inline="true" :rules="rules1"
                           class="demo-ruleForm h-formbLine h-formbLine1">
                    <el-form-item label="许可证号" class="h-elformWrap-2" :prop="this.haveThree6840 == 1? 'licenseNumber': '' "
                                  v-if="this.haveThree6840 == 1">
                      <el-input v-model="formLabelAlign1.bscUserInfoAgentSell.licenseNumber"
                                placeholder="请输入许可证号" :disabled="isQuyu == true" >
                      </el-input>
                    </el-form-item>

                  </el-form>
                  <div style="text-align: center">
                    <el-button class="h-btn h-bBtn h-bgblueQ2" type="primary" @click="updateAgentJbxn('formLabelAlign1','0')" v-if="!this.isFreezeData">提交修改
                    </el-button>
                  </div>
                </div>
              </el-collapse-item>
              <el-collapse-item name="5" v-if="!isShangWei">
                <template slot="title" v-if="flag==='2'||flag==='3'||flag==='4'">
                  <div style="display: flex;align-items: center" @click.stop>
                    <span class="collapseTitle" style="color:#0e75e9">资质审核</span>
                  </div>
                </template>
                <div class="signsign" v-if="flag==='2'||flag==='3'||flag==='4'">
                  <el-form class="h-formLine" :model="formLabelAlign1.bscUserInfoAgentBasic" label-position="right" label-width="120px" ref="formLabelAlign13" :rules="rules1">
                    <el-row :gutter="20">
                      <el-col :span="6">
                        <el-form-item label="经销商类别" prop="agentLevel">
                          <brselect category="DealerCategory_type" v-model="formLabelAlign1.bscUserInfoAgentBasic.agentLevel"
                                    :v="formLabelAlign1.bscUserInfoAgentBasic.agentLevel"
                                    @change="changDealer($event)"
                                    :disabled="isQuyuXg"
                                    style="width: 80%"
                                    placeholder="请选择">
                          </brselect>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="对阵一级经销商" prop="oneLevelAgentName" v-if="formLabelAlign1.bscUserInfoAgentBasic.agentLevel==2 || formLabelAlign1.bscUserInfoAgentBasic.agentLevel==5">
                          <el-select v-model="formLabelAlign1.bscUserInfoAgentBasic.oneLevelAgentName"
                                     :title="formLabelAlign1.bscUserInfoAgentBasic.oneLevelAgentName"
                                     remote filterable :filter-method="showAgentList" clearable  placeholder="请输入"
                                     :remote-method="showAgentList" @change="changeAgent($event)" >
                            <el-option v-for="(item) in oneAgentList"
                                       :key="item.customerName"
                                       :label="item.customerName"
                                       :value="item">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                  <div v-if="agentType!=3">
                    <el-form :model="formLabelAlign1" label-position="right" ref="formLabelAlign11"
                           :rules="rules1" class="h-formLine" label-width="120px">
                      <div v-for="(listIt, index) in formLabelAlign1.contractList" :key="index">
                        <el-row :gutter="20">
                          <el-col :span="6">
                            <el-form-item label="合同号" prop="contractId">
                              <el-input
                                  :title="formLabelAlign1.contractList[index].id"
                                  v-model="formLabelAlign1.contractList[index].id"
                                  disabled
                                  style="width: 80%"
                              />
                            </el-form-item>
                          </el-col>
                          <el-col :span="6">
                            <el-form-item label="目标对阵用户数量" prop="contractId">
                              <el-input
                                  :title="formLabelAlign1.contractList[index].userNum"
                                  v-model="formLabelAlign1.contractList[index].userNum"
                                  disabled
                              />
                            </el-form-item>
                          </el-col>
                        </el-row>


                      </div>
                    </el-form>
                  </div>
                  <el-tabs type="border-card"  @tab-click="handleTab" v-model="cardName">
                    <el-tab-pane label="总部" name="总部">
                      <template>
                        <el-form :model="formLabelAlign1.bscUserInfoAgentSell" label-position="right" ref="formLabelAlign11"
                                 :inline="true" :rules="rules1" class="demo-ruleForm h-formbLine h-formbLine1" v-if="agentType!=3">
                          <div v-for="(item,index) in formLabelAlign1.ctList" :key="index">
                            <el-button
                                v-if="index === 0"
                                @click="addIndustry"
                                :disabled="isQuyuXg"
                                type="text"
                                size="mini"
                                style="float:right;font-size:20px;margin-right: -5px"
                                icon="el-icon-circle-plus"
                                circle
                                title="添加">
                            </el-button>
                            <el-button
                                @click="deleteIndustry(index)"
                                :disabled="isQuyuXg"
                                v-if="index !== 0"
                                type="text"
                                style="float:right;font-size:20px;margin-right: -5px;color:crimson;"
                                size="mini"
                                icon="el-icon-remove"
                                circle
                                title="删除"
                            ></el-button>
                            <el-form-item label="产业" class="h-elformWrap-2" prop="goodsCategory"
                                          v-if="agentType!=3"  style="margin-left: -0.71rem;">
                              <brselect category="swyl_industry" :v="formLabelAlign1.ctList[index].field" :disabled="isQuyuXg" v-model="formLabelAlign1.ctList[index].field"
                                        style="width:100%"/>
                            </el-form-item>
                            <el-form-item label="渠道" class="h-elformWrap-2" prop="goodsCategory" v-if="item.field!='C5' && item.field!='C7'"
                                         style="margin-left: -0.71rem;">
                              <el-select :multiple="true"
                                         :clearable="true"
                                         style="width: 4rem"
                                         :disabled="isQuyuXg"
                                         v-model="formLabelAlign1.ctList[index].channelList"
                                         :v="formLabelAlign1.ctList[index].channelList"
                                         @change="getQudaoCt"
                                         :placeholder="flag==='2'?'':'请选择'">
                                <el-option v-for="item in qudaoCt"
                                           :key="item.index"
                                           :value="item.code"
                                           :label="item.name"
                                ></el-option>
                              </el-select>
                            </el-form-item>

                            <el-form-item label="渠道" class="h-elformWrap-2" prop="goodsCategory" v-if="item.field=='C5' || item.field=='C7'"
                                          style="margin-left: -0.71rem;">
                              <el-select :multiple="true"
                                         :clearable="true"
                                         style="width: 4rem"
                                         :disabled="isQuyuXg"
                                         v-model="formLabelAlign1.ctList[index].channelList"
                                         :v="formLabelAlign1.ctList[index].channelList"
                                         @change="getQudaoCt"
                                         :placeholder="flag==='2'?'':'请选择'">
                                <el-option v-for="item in qudaoND5"
                                           :key="item.index"
                                           :value="item.code"
                                           :label="item.name"
                                ></el-option>
                              </el-select>
                            </el-form-item>

                            <el-form-item label="返利类型" class="h-elformWrap-2" prop="goodsCategory" style="margin-left: 1.71rem;" v-if="ct && formLabelAlign1.bscUserInfoAgentBasic.agentLevel!='3'">
                              <el-select v-if="ct && formLabelAlign1.bscUserInfoAgentBasic.agentLevel!='3'&& formLabelAlign1.bscUserInfoAgentBasic.agentLevel!='6'" v-model="formLabelAlign1.ctList[index].flType" @change="ctSelect"
                                         style="width: 2rem!important;margin-left: 0.2rem;" clearable
                                         placeholder="请选择">
                                <el-option label="一级经销商" value="01"></el-option>
                                <el-option label="地市直营商" value="06"></el-option>
                                <el-option label="分销商3.0" value="05"></el-option>
                              </el-select>
                              <el-select v-if="ct && formLabelAlign1.bscUserInfoAgentBasic.agentLevel=='6'" v-model="formLabelAlign1.ctList[index].flType" @change="ctSelect"
                                         style="width: 2rem!important;margin-left: 0.2rem;"
                                         placeholder="请选择">
                                <el-option label="地市直营商" value="06"></el-option>
                              </el-select>
                            </el-form-item>
                            <el-form-item label="产品价格" :style="{marginLeft: ct && formLabelAlign1.bscUserInfoAgentBasic.agentLevel!='3'?'0':'1.71rem'}">
                              <el-select v-if="ct && isZhiDan!=1" v-model="formLabelAlign1.ctList[index].level" @change="ctSelect"
                                         style="width: 1.5rem!important;margin-left: 0.2rem;"
                                         placeholder="请选择">
                                <el-option label="未签约" value=""></el-option>
                                <el-option label="一级产品价格" value="01"></el-option>
                                <el-option label="二级产品价格" value="02"></el-option>
                                <el-option label="三级产品价格" value="03"></el-option>
                                <el-option label="分销商价格" value="05" v-if="formLabelAlign1.bscUserInfoAgentBasic.agentLevel != '1'"></el-option>
                              </el-select>
                              <el-select v-if="ct && isZhiDan==1" v-model="formLabelAlign1.ctList[index].level" @change="ctSelect"
                                         style="width: 1.5rem!important;margin-left: 0.2rem;"
                                         placeholder="请选择">
                                <el-option label="未签约" value=""></el-option>
                                <el-option label="直单价格" value="04"></el-option>
                              </el-select>
                            </el-form-item>
                          </div>
                        </el-form>
                      </template>
                    </el-tab-pane>
                    <el-tab-pane v-for="item in LQList" :label="item.companyName" :name="item.companyName" :key="item.lianqun">
                      <el-form label-position="right" ref="formLabelAlign11"
                               :inline="true" :rules="rules1" class="demo-ruleForm h-formbLine h-formbLine1">
                        <el-form-item label="渠道" class="h-elformWrap-2" prop="goodsCategory" style="margin-left: -0.5rem;">
                          <el-select @change="changeQudao" v-model="addForm[`${item.companyCode}Channel`]" :clearable="true" :multiple="true" filterable placeholder="请选择"  style="width: 4rem">
                            <el-option
                                v-for="items in item.channelList"
                                :key="items.code"
                                :label="items.name"
                                :value="items.code">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="产品价格" class="h-elformWrap-2" prop="goodsCategory" style="margin-left: 2rem;">
                          <el-select v-if="ct && isZhiDan!=1" v-model="addForm[`${item.companyCode}`]"
                                     placeholder="请选择"
                                     @change="changeQudao">
                            <el-option label="未签约" value=""></el-option>
                            <el-option label="一级产品价格" value="01"></el-option>
                            <el-option label="二级产品价格" value="02"></el-option>
                            <el-option label="三级产品价格" value="03"></el-option>
                            <el-option label="分销商价格" value="05" v-if="formLabelAlign1.bscUserInfoAgentBasic.agentLevel != '1'"></el-option>
                          </el-select>
                          <el-select v-if="ct && isZhiDan==1" v-model="addForm[`${item.companyCode}`]"
                                     placeholder="请选择" @change="changeQudao">
                            <el-option label="未签约" value=""></el-option>
                            <el-option label="直单价格" value="04"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-form>
                    </el-tab-pane>

                  </el-tabs>
                  <el-form :model="formLabelAlign1.bscUserInfoAgentSell" label-position="right"
                      ref="formLabelAlign11"
                      :inline="true" :rules="rules1" class="demo-ruleForm h-formbLine h-formbLine1">
                    <el-form-item label="客户种类" class="h-elformWrap-2" prop="accountDistributeGroup">
                      <el-select
                          v-model="formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup"
                          :disabled="is91"
                          @change="changeFlag"
                          :title="
                                                      formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup == 10 ? '内销-海尔集团内（指国内市场所有海尔关联公司）':
                                                      formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup == 20 ? '内销-海尔集团外（指国内市场所有非海尔关联公司）':
                                                      formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup == 30 ? '外销-海尔集团内（指海外市场所有海尔关联公司）':
                                                      formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup == 40 ? '外销-海尔集团外（指海外市场非海尔关联公司）':
                                                      formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup == 50 ? '外销-合并范围内':
                                                      formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup == 60 ? '内销-合并范围内':
                                                ''"
                          placeholder="请选择">
                        <el-option label="内销-海尔集团内（指国内市场所有海尔关联公司）-10" value="10"></el-option>
                        <el-option label="内销-海尔集团外（指国内市场所有非海尔关联公司）-20" value="20"></el-option>
                        <el-option label="外销-海尔集团内（指海外市场所有海尔关联公司）-30" value="30"></el-option>
                        <el-option label="外销-海尔集团外（指海外市场非海尔关联公司）-40" value="40"></el-option>
                        <el-option label="外销-合并范围内 -50" value="50"></el-option>
                        <el-option label="内销-合并范围内 -60" value="60"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="签约性质" class="h-elformWrap-2" prop="customerGroup2">
                      <el-select
                          v-model="formLabelAlign1.bscUserInfoAgentSell.customerGroup2"
                          @change="changeFlag"
                          placeholder="请选择">
                        <el-option label="签约经销商" value="01"></el-option>
                        <el-option label="非签约经销商" value="02"></el-option>
                        <!--                                            <el-option label="直单用户" value="03"></el-option>-->
                      </el-select>
                    </el-form-item>
                    <el-form-item label="分销渠道" class="h-elformWrap-2" prop="distributionChannel">
                      <brselectlazy category="YlSalesChannel_agent"
                                    @change="changeFlag"
                                    :v="formLabelAlign1.bscUserInfoAgentSell.distributionChannel"
                                    v-model="formLabelAlign1.bscUserInfoAgentSell.distributionChannel"
                                    :clearable="true"
                                    style="width:2.27rem"/>
                    </el-form-item>
                    <el-form-item label="销售区域" class="h-elformWrap-2 w-elformWrap" prop="salesRegion">
                      <brselectlazy :multiple="true" category="YlSalesArea_chanpin"
                                    @change="changeArea($event)"
                                    v-if="this.agentType != '3'"
                                    :disabled="isQuyuXg"
                                    :v="formLabelAlign1.bscUserInfoAgentSell.salesRegion"
                                    v-model="formLabelAlign1.bscUserInfoAgentSell.salesRegion"
                                    :clearable="true"/>
                      <div v-if="this.agentType == '3'">
                                                        <SPAN v-if="this.isExpandAuthority != '1'">

                                                            <brselectlazy :multiple="true" category="YlSalesArea"
                                                                          @change="changeFlag"
                                                                          :v="formLabelAlign1.bscUserInfoAgentSell.salesRegion"
                                                                          v-model="formLabelAlign1.bscUserInfoAgentSell.salesRegion"
                                                                          :clearable="true"/>
                                                        </SPAN>
                        <span v-else>

                                                            <brselectlazy :multiple="true" category="YlSalesArea_chanpin"
                                                                          @change="changeFlag"
                                                                          :v="formLabelAlign1.bscUserInfoAgentSell.salesRegion"
                                                                          v-model="formLabelAlign1.bscUserInfoAgentSell.salesRegion"
                                                                          :clearable="true"/>
                                                        </span>

                      </div>

                    </el-form-item>

                    <el-form-item label="销售地市" class="h-elformWrap-2 w-elformWrap" prop="salesCity" v-if="this.agentType != '3'">
                      <el-select :multiple="true"
                                 :clearable="true"
                                 :disabled="isQuyuXg"
                                 v-model="formLabelAlign1.bscUserInfoAgentSell.salesCity"
                                 :v="formLabelAlign1.bscUserInfoAgentSell.salesCity"
                                 @change="getCity"
                                 :placeholder="flag==='2'?'':'请选择'">
                        <el-option v-for="item in salesCity"
                                   :key="item.index"
                                   :value="item.code"
                                   :label="item.name"
                        ></el-option>
                      </el-select>
                    </el-form-item>

                  </el-form>
                  <el-form-item label="销售地市" class="h-elformWrap-2 w-elformWrap" prop="salesCity" v-if="this.agentType != '3'">
                    <el-select :multiple="true"
                               :clearable="true"
                               :disabled="isQuyuXg"
                               v-model="formLabelAlign1.bscUserInfoAgentSell.salesCity"
                               :v="formLabelAlign1.bscUserInfoAgentSell.salesCity"
                               @change="getCity"
                               :placeholder="flag==='2'?'':'请选择'">
                      <el-option v-for="item in salesCity"
                                 :key="item.index"
                                 :value="item.code"
                                 :label="item.name"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form :model="formLabelAlign1.bscUserInfoAgentBasic" label-position="right"
                           ref="formLabelAlign12"
                           :inline="true" :rules="rules1" class="demo-ruleForm h-formbLine h-formbLine1">
                    <el-form-item label="签约公司" class="h-elformWrap-2 w-elformWrap" prop="companyCode">
                      <brselectlazy :multiple="true" category="YlCompanyCode_agent"
                                    @change="companyCodeChange($event)"
                                    :v="formLabelAlign1.bscUserInfoAgentBasic.companyCode"
                                    v-model="formLabelAlign1.bscUserInfoAgentBasic.companyCode"
                                    :clearable="true"
                                    style="width:100%"/>
                    </el-form-item>
                    <el-form-item label="附件" class="h-elformWrap-2" prop="upload9" v-if="isZhiDan">
                      <brupload
                          v-model="formLabelAlign1.bscUserInfoAgentBasic.upload9"
                          v-if="fileShowFlag"
                          :refid="refid"
                          reftype="代理商注册-附件"
                          :uploadflag="true"
                          :delflag="true"
                          @filecallback="fileBack4"
                          :showtime="false">
                      </brupload>
                    </el-form-item>
                    <el-form-item label="修改原因" class="h-elformWrap-2 w-elformWrap" prop="reason" v-if="this.agentType!=3">
                      <el-input type="textarea" v-model="formLabelAlign1.bscUserInfoAgentBasic.reason" :clearable="true" style="margin-left:0.1rem;"></el-input>
                    </el-form-item>
                    <el-form-item label="修改证明" class="h-elformWrap-2" prop="upload10" v-if="this.agentType!=3">
                      <brupload
                          v-model="formLabelAlign1.bscUserInfoAgentBasic.upload10"
                          :refid="refidxg"
                          reftype="代理商修改-修改附件"
                          uploadflag
                          delflag
                          :before-upload="beforeUpload"
                          @filecallback="fileBack10"
                          :showtime="false"
                      >
                      </brupload>
                    </el-form-item>
                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;" v-if="this.isFreezeData">
                      <h1>解冻信息</h1>
                    </div>
                    <el-form-item label="到期日调整" class="h-elformWrap-1 w-elformWrap" v-if="this.isFreezeData">
                      <el-date-picker type="date" placeholder="选择时间" class="h-tableInput" style="width: 20%;" @change="changeFlag" v-model="formLabelAlign1.bscUserInfoAgentBasic.validityPeriodDate"
                                      :picker-options="pickerOptions"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="解冻原因" class="h-elformWrap-1 w-elformWrap"  v-if="this.isFreezeData">
                      <el-input type="textarea" v-model="formLabelAlign1.bscUserInfoAgentBasic.reason" @change="changeFlag" :clearable="true" ></el-input>
                    </el-form-item>
                    <br>
                    <el-form-item label="上传附件" class="h-elformWrap-2" v-if="this.isFreezeData">
                      <brupload
                          :refid="instidThaw"
                          reftype="代理商修改-解冻附件"
                          uploadflag
                          delflag
                          :showtime="false"
                      >
                      </brupload>
                    </el-form-item>
                  </el-form>
                </div>
              </el-collapse-item>
              <el-collapse-item name="6" v-if="agentType!=3">
                <template slot="title">
                  <div style="display: flex;align-items: center" @click.stop>
                    <span class="collapseTitle" style="color:#0e75e9">修改附件记录</span>
                  </div>
                </template>
                <el-table
                    ref="multipleTable"
                    :data="fileList"
                    stripe
                    border
                    style="width: 100%">
                  <el-table-column
                      type="index"
                      fixed
                      label="#"
                      width="40">
                  </el-table-column>
                  <el-table-column
                      prop="cuname"
                      label="修改人名称"
                      :show-overflow-tooltip="true"
                      fixed
                      min-width="90">
                  </el-table-column>
                  <el-table-column
                      prop="cucode"
                      label="修改人编码"
                      :show-overflow-tooltip="true"
                      fixed
                      min-width="110">
                  </el-table-column>
                  <el-table-column
                      prop="cdate"
                      label="修改时间"
                      :show-overflow-tooltip="true"
                      fixed
                      value-format="yyyy-MM-dd"
                      min-width="110">
                  </el-table-column>
                  <el-table-column
                      prop="reason"
                      label="修改原因"
                      :show-overflow-tooltip="true"
                      fixed
                      min-width="110">
                  </el-table-column>
                  <el-table-column
                      label="修改附件"
                      :show-overflow-tooltip="true"
                      fixed
                      min-width="110">
                    <template slot-scope="scope">
                      <brupload
                          :refid="scope.row.fileId"
                          reftype="代理商修改-修改附件"
                          :uploadflag="false"
                          :delflag="false"
                          :showtime="false">
                      </brupload>
                    </template>
                  </el-table-column>
                </el-table>
                <div style="display:flex;justify-content: flex-end;align-items:center;">
                  <paginationmin :page="mf" @query="agentUpdateFile"/>
                </div>
              </el-collapse-item>
            </el-collapse>

            <!-- 修改：{{this.data.isExpandAuthorityBas}}
                        血站：{{this.data.isBloodBas}} -->

          </div>
        </div>
      </div>
      <div class="bannerBox" v-if="this.flag==='2'||this.flag==='3'||this.flag==='4'">
        <div class="h-row h-mrt1">
          <div class="h-rowIn">
            <div class="h-rowBox" v-show="this.flag != 2">
              <div class="h-rowCon">
                <div class="h-pieceIn2">
                  <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                  <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                    <h1>审核信息</h1>
                  </div>
                  <div>
                    <div class="h-formLine weekplandetail12" style="position: relative;">
                      <el-form :inline="true" :model="formLabelAlign1.bscUserInfoAgentSell"
                               ref="formLabelAlign13" :rules="rules1">
                        <el-form-item label="审批意见" class="h-elformWrap-2 newBox"
                                      :required="true" style="width: 100%!important;"
                                      prop="auditMind1">
                          <el-input v-model="formLabelAlign1.bscUserInfoAgentSell.auditMind1"
                                    placeholder="请输入"></el-input>
                        </el-form-item>
                        <!--                                                <el-form-item>-->
                        <!--                                                    <el-select v-model="" placeholder="是否跳过领导审批">-->
                        <!--                                                        <el-option label="是" value="1"></el-option>-->
                        <!--                                                        <el-option label="否" value="0"></el-option>-->
                        <!--                                                    </el-select>-->
                        <!--                                                </el-form-item>-->
                      </el-form>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="text-align: center;margin-top: 0.5rem">
        <el-button class="h-btn h-bBtn h-bgwhite"
                   @click="goBack">返回
        </el-button>
        <el-button class="h-btn h-bBtn h-bgblueQ2" type="primary" @click="updateShangWei('formLabelAlign1','1')" v-if="this.isFreezeData"
        >提交解冻
        </el-button>
        <el-button class="h-btn h-bBtn h-bgblueQ2" type="primary" @click="updateShangWei('formLabelAlign1','0')" v-if="!this.isFreezeData && this.gnsc"
        >提交修改
        </el-button>
        <el-button class="h-btn h-bBtn h-bgblueQ2" type="primary" @click="updateShangWei('formLabelAlign1','0')" v-if="!this.isFreezeData && !this.gnsc"
        >提交修改
        </el-button>
        <el-button v-if="!isShangWei && !this.isFreezeData" class="h-btn h-bBtn h-bggreen" type="primary" @click="expandShangWei('formLabelAlign1')"
        >扩展公司范围
        </el-button>
        <el-button class="h-btn h-bBtn" @click="viewpress"
                   v-if="this.flag==='3'||this.flag==='4'">
          审批跟踪
        </el-button>
      </div>
    </div>
    <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
    <areaSelect :visible.sync="showflag2" @choseObj="choseObj2" v-if="showflag2"
                v-model="formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom"
    />
    <!-- <areaSelect :visible.sync="showflag" @choseObj="choseObj"  v-if="showflag" v-model="formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom" /> -->
    <areaSelect :visible.sync="showflag" @choseObj="choseObj" v-if="showflag"
                v-model="formLabelAlign1.bscUserInfoAgentCompany.mailaddress"
    />
  </div>
</template>
<script>
import ss from '../../../api/SystemService';
import agentCopyService from "../../../api/loud/agent/agentCopyService";
import uploadFile from "../../../api/process/account_complainUploadService";
import util from "../../../utils/util";

export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.check.checkpassword !== '') {
          this.$refs.formLabelAlign1a.validateField('checkpassword');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.formLabelAlign1.bscUserInfo.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    var validateCompany = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入公司名称'));
      } else if (value !== '') {
        ss.SignService.checkNewCompany(value, this.formLabelAlign1.bscUserInfoAgentBasic.usercode).then(response => {
          console.log(response, '验证公司信息')
          if (response.obj.status === '200') {
            this.companyData = response.obj.data;
            callback();
            this.formLabelAlign1.bscUserInfoAgentBasic.companyAddress = this.companyData.address;
            // this.formLabelAlign1.bscUserInfoAgentBasic.http = this.companyData.websites[0].web_url;
            this.formLabelAlign1.bscUserInfoAgentBasic.companytype = this.companyData.econ_kind;
            this.formLabelAlign1.bscUserInfoAgentBasic.founded = this.companyData.start_date;
            this.formLabelAlign1.bscUserInfoAgentBasic.regmoney = this.companyData.regist_capi;
            this.formLabelAlign1.bscUserInfoAgentBasic.legal = this.companyData.oper_name;
            this.formLabelAlign1.bscUserInfoAgentBasic.business = this.companyData.scope;
            this.formLabelAlign1.bscUserInfoAgentBasic.taxCode = this.companyData.credit_no;
            this.formLabelAlign1.bscUserInfoAgentBasic.streetRoom = this.companyData.address;
            this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber = this.companyData.contact.telephone;
          } else {
            callback(new Error('请输入正确的公司名称!'));
          }
        })

      }
    };
    return {
      isShowAllSelect:false,//判断是否展示全部群连并checkout
      haveThree6840:false, //包含III类6840,默认否
      licenseNumber:'',//许可证号
      value1: true,
      value2: false,
      taxCode: false,
      phoneNumber: false,
      cityStreetRoom: false,
      bankBranchCode: false,
      bankName: false,
      accountHolderName: false,
      bankCountry: false,
      customerGroup1: false,
      changedParamList: [],
      isZhiDan: false,
      isExpandAuthority:false,//是否海外直单权限
      isBlood:false,//是否血站
      isGoverment: false,
      // isShowSkipLeader: false,
      isShangWei: false,
      ctLevel: '',
      dealerType:'',
      scoreType:'updateShangWei',
      ct: true,
      isCt:false,
      haiwairen: false,
      guanliren: false,
      checkedlevels: [],
      addli: [],
      oneAgentList:[],
      lianqunList:[],
      lianqunListCt:[],
      qudaoNotMain:[],
      salesCity:[],//销售地区
      qudaoCt:[],
      qudaoND5:[],
      qudaoL1:[],
      qudaoL2:[],
      qudaoListL1:[],
      qudaoListL2:[],
      fieldList:[
        {name:'医疗创新领域',code:'L1'},
        {name:'生命科学领域',code:'L2'}
      ],
      fields:[],
      associatedCompanyList:[],
      qudao:[],
      levels: ['传统产品', 'U血液', 'U试剂', 'U疫苗'],
      checkAll: false,
      isIndeterminate: true,
      havepolicy2017:false,
      have6858: false,
      have6840: false,
      have6854: false,
      have1101: false,
      have2214: false,
      have2215: false,
      have2216: false,
      showhistory: false,
      instid: null,
      companyData: null,
      showflag: false,
      showflag2: false,
      have2: true,
      have3: false,
      options: [],
      value: [],
      listSelect: [],
      loadingSelect: false,
      states: [],
      isShowMassage: true,
      radio: '国内客户',
      fileShowFlag: false,
      uploadflag: true,
      delflag: true,
      refid: this.$util.getUuid(),
      refidxg: this.$util.getUuid(),
      instidThaw: this.$util.getUuid(),
      loading: false,
      isQuyu: false,
      isQuyuXg:false,
      updateCompany:false,
      isTwoAgent:false,
      isFreezeData:false,
      gnsc:true,
      is91:false,
      ind: null,
      index: ['c', 'd', 'e', 'f', 'h', 'i','1','2','3'],
      index1: ['c','d','e','f','1','2','4'],
      index2: ['c','d','e','f'],
      list: ["我是经销商", "我是供应商"],
      indx: 0,
      chflag: 0,
      companyCodeNumFlag:0,
      agentLevel:'',
      oneLevelAgent:'',
      formLabelAlign1: {
        bscUserInfoAgentBasic: {
          usercode: null,
          customerNumber: null,
          accountGroup: null,// 科目组 , 配置项 , 调接口参数: YlCustomerAccountGroup , 字段输入限制:  0210 集团内客户 0260 海外客户 0280 国内客户 根据客户实际情况传入科目组代码  , 特殊限制:   付款条件销售平台更改
          customerName1: '',// 客户全称1 ,  ,   , 字段输入限制: 客户全名。国内客户要求与证件注册的名称相同 , 特殊限制:   更改账期接口（公司销售视图付款条件字段）
          customerTitle: null,// 客户标题 ,  ,   , 字段输入限制:  公司 先生 女士 先生和夫人 一般公司类客户数据，可以默认传入“公司”  ,
          searchTerm: null,// 搜索项 ,  ,   ,   ,
          postalCode: null,// 邮政编码 ,  ,   ,   ,
          country: null,// 国家代码 , 配置项 , 调接口参数: YlCountry , 字段输入限制: 传入国家的代码，在list中选择 ,
          region: null,// 地区 , 配置项 , 调接口参数: YlRegion , 字段输入限制: 传入地区的代码，在国家代码下的list中选择 ,
          cityStreetRoom: '',// 城市 ,  ,   , 字段输入限制: 客户所在的城市中文名 ,
          streetRoom: null,// 街道 ,  ,   , 字段输入限制: 客户证件上的注册地址 ,
          phoneNumber: null,// 电话 ,  ,   , 字段输入限制: 客户证件上注册的电话，开发票使用 , 特殊限制: 最多16位
          language: null,// 语言代码 , 配置项 , 调接口参数: YlLanguageType , 字段输入限制: 默认传入“ZH” ,
          faxNumber: null,// 传真 ,  ,   ,   , 特殊限制: 最多16位
          contactMobilePhone: null,// 移动电话 ,  ,   ,   , 特殊限制: 最多16位
          companyCodeGeneral: null,// 公司代码(记录0210账户组下客户公司对照关系) , 配置项 , 调接口参数: CompanyCode , 字段输入限制: 当建立集团内客户时，此字段不能为空，需传入集团4位公司代码 ,
          companyCode: null,// 公司代码 , 是否必填: 是 , 是否配置项: 是 , 值集代码: YlCompanyCode , 注释:
          goodsCategory: null,// 商品大类 , 是否必填：否 , 是否配置项：是 , 值集代码：YlGoodsCategory
          taxCode: null,// 纳税人登记号 ,  ,   , 字段输入限制: 客户证件注册的统一信用代码，开发票使用 ,
          name1: null,// 联系人名称 ,  ,   , 字段输入限制: 客户方联系人的名字 ,
          phoneNumber1: null,// 联系人电话1 ,  ,   , 字段输入限制: 客户方联系人的电话 , 特殊限制: 最多16位
          companyAddress: null,// 公司地址名 ,  ,   ,   ,
          contactCity: null,// 联系人城市 ,  ,   ,   ,
          appellation: null,// 称谓 ,  ,   , 字段输入限制:  女士 先生  ,
          partnerFlagSp: null,// 是否有售达方功能,1:有;0:无 ,  ,   , 字段输入限制: 默认传“1” , 特殊限制: 一旦创建不可修改
          partnerFlagSh: null,// 是否有送达方功能,1:有;0:无 ,  ,   , 字段输入限制: 默认传“1” , 特殊限制: 一旦创建不可修改
          partnerFlagBp: null,// 是否有开票方功能,1:有;0:无 ,  ,   , 字段输入限制: 默认传“1” , 特殊限制: 一旦创建不可修改
          partnerFlagPy: null,// 是否有付款方功能,1:有;0:无 ,  ,   , 字段输入限制: 默认传“1” , 特殊限制: 一旦创建不可修改
          cucode: null,//创建人编码
          cuname: null,//创建人名称
          cdate: null,//创建时间
          lucode: null,//修改人编码
          ldate: null,//最后更新时间
          delflag: null,//可用标志。1：可用，0：删除标志
          scale: null,//纳税人规模  0：小规模经营者   1：一般纳税人
          http: null,//公司网址
          companytype: null, //公司性质
          founded: null,//成立时间
          regmoney: null,//注册资本
          legal: null,//法人姓名
          introduce: null,//公司简介
          business: null,//主营
          achievement: null,//业绩
          personnelNum:null,//销售人员数量
          brand:null,//经营其他品牌
          legalPhone:null,//总经理联系方式
          resource: null,//资源
          email: null,//公司邮箱
          upload5: null,
          upload6: null,
          upload8: null,
          isTrade: null,
          remark:null,
          agentLevel:null,
          oneLevelAgent:null,
          oneLevelAgentName:null,
          associatedCompanyName:null,//关联公司
          associatedCompanyCode:null,
          upload9:[],
          upload10:[],
          contractId:null,//经销商签约合同
          refidxg:null,//修改文件id
          reason:null,
          validityPeriodDate:null,
          instidThaw:null,
        },
        bscUserInfoAgentBank: {
          usercode: null,//公司编码
          accountHolderName: null,// 银行帐户 ,  ,   , 字段输入限制: 开户许可证上的银行账号 ,
          bankCountry: null,// 银行所属国家 , 配置项 , 调接口参数: YlCountry , 字段输入限制: 从国家列表中选择 ,
          bankBranchCode: null,// 银行码 , 配置项 , 调接口参数: 从MDM开放的银行接口中选择 , 字段输入限制: 从MDM开放的银行接口中选择 ,
          cucode: null,//创建人编码
          cuname: null,//创建人名称
          cdate: null,//创建时间
          lucode: null,//修改人编码
          ldate: null,//最后更新时间
          delflag: null,//可用标志。1：可用，0：删除标志
          vatCode: null,//VAT税号
          bankName: null//银行名称
        },
        bscUserInfoAgentSell: {
          usercode: null,//公司编码
          distributionChannel: null,// 分销渠道 , 配置项 , 调接口参数: YlSalesChannel ,   ,
          division: null,// 产品组 , 配置项 , 调接口参数: YLProductGroup , 字段输入限制: 默认00 ,
          salesGroup: null,// 销售组织 , 配置项 , 调接口参数: YLSalesOrganization ,   ,
          salesRegion: '',// 销售地区 , 配置项 , 调接口参数: YlSalesArea ,   ,
          customerGroup: null,// 客户组(经销商级别) , 配置项 , 调接口参数: YlCustomerGroup , 字段输入限制: 内销必填 ,
          currencyCode: null,// 货币代码 , 配置项 , 调接口参数: YlCurrency ,   ,
          customerPricingProccess: null,// 客户定价过程 , 配置项 , 调接口参数: 默认传1 , 字段输入限制: 默认传1 ,
          customerSummaryGroup: null,// 客户统计组 , 配置项 , 调接口参数: 默认传1 , 字段输入限制: 默认传1 ,
          shipCondition: null,// 装运条件 , 配置项 , 调接口参数: 默认传01 , 字段输入限制: 默认传01 ,
          shipPlant: null,// 交货工厂 , 配置项 , 调接口参数: YlPLPlantCode ,   ,
          accountDistributeGroup: null,// 客户组的帐户分配 , 配置项 , 调接口参数: YlAccountDistributeGroup ,   ,
          custTaxCategory: null,// 客户的税分类 , 配置项 , 调接口参数: 默认传1 , 字段输入限制: 默认传1 ,
          paymentTerms1: null,// 付款条件-未包含在最近模板 , 配置项 , 调接口参数: YlPayTerm , 字段输入限制: 默认传0000 ,
          podRelation: null,// 与 POD 处理相关 ,  ,   , 字段输入限制: 传X或空  默认传空 ,
          orderPossibility: null,// 订单可能性 ,  ,   ,   ,
          intCommercialTerms: null,// 国际贸易条件 , 配置项 , 调接口参数: YlCommercialTerms , 字段输入限制: 外销必填 ,
          intCommercialTerms2: null,// 国际贸易条件(部分2) ,  ,   , 字段输入限制: 外销必填 ,
          fullDelivery: null,// 全部交货 ,  ,   , 字段输入限制: 传X或空  默认传空 ,
          partDelivery: null,// 每个项目允许的部分交货最大数 ,  ,   , 字段输入限制: 默认传9 ,
          orderComposeIdentif: null,// 订单组合标识 ,  ,   , 字段输入限制: 传X或空  默认传X ,
          customerGroup1: null,// 客户组 1(开票类型) , 配置项 , 调接口参数: YlCustomerGroup1 , 字段输入限制: 内销必填 ,
          customerGroup2: null,// 客户组 2(经销商类型) , 配置项 , 调接口参数: YlCustomerGroup2 , 字段输入限制: 内销必填 ,
          customerGroup3: null,// 客户组 3(渠道类型) , 配置项 , 调接口参数: YlCustomerGroup3 , 字段输入限制: 内销必填 ,
          customerGroup3NotMain:null,//客户组 3(渠道类型 非主渠道)
          inEmail: null, //邮箱
          rebate: null,// 回扣 ,  ,   , 字段输入限制: 传X或空  默认传空 ,
          closeRoundingOff: null,// 关闭舍入 ,  ,   , 字段输入限制: 传X或空  默认传空 ,
          permit: null,//资质标识 1二级 2三级
          cucode: null,//创建人编码
          cuname: null,//创建人名称
          cdate: null,//创建时间
          lucode: null,//修改人编码
          ldate: null,//最后更新时间
          delflag: null,//可用标志。1：可用，0：删除标志
          customerAssignGroup: '0210', //客户分配账户组: 10内销-集团内 20内销-集团外
          auditMind1: null, //审核意见
          auditMind2: null, //审核意见
          licenseNumber:null,// 许可证号
          agentLevel:null,//经销商级别
          dealerType:null,//经销商类别
          xkzEffectiveDate:'',//许可证有效到期日
          yyzzEffectiveDate:'',//营业执照有效日期
          salesCity:'',//销售地市
          invInformation:null,//开票信息
          havepolicy2017:'0',//是否包含2017版分类目录
        },
        bscUserInfoAgentCompany: {
          usercode: null,//公司编码
          companyCode: null,// 公司代码 , 配置项 , 调接口参数: YlCompanyCode ,   ,
          hq: null,// 总部 ,  ,   ,   ,
          reconcileAccount: null,// 统驭科目 , 配置项 , 调接口参数: YLReconcileAccount , 字段输入限制:  0230、0260、0280账户组默认1122002000 0210默认1122001000  ,
          sequenceNo: null,// 排序码 , 配置项 , 调接口参数: YlOrderCode , 字段输入限制: 默认001 ,
          paymentTerm: null,// 付款条款 , 配置项 , 调接口参数: YlPayTerm , 字段输入限制: 默认0000 ,
          cucode: null,//创建人编码
          cuname: null,//创建人名称
          cdate: null,//创建时间
          lucode: null,//修改人编码
          ldate: null,//最后更新时间
          delflag: null,//可用标志。1：可用，0：删除标志
          mailreceiver: null,//邮寄接收人
          receiverphone: null,//接收人电话
          mailaddress: null,//邮寄地址
        },
        bscUserInfo: {
          usercode: null,//员工编码/公司编码
          password: '',//密码
          usertype: null,//用户类别: 0-内部员工  1-经销商  2-供应商
          username: '',//公司名称/员工姓名username
          email: null,//邮箱
          phone: null,//联系人电话
          deptcode: null,//所属部门编码deptcode  公司用户为空
          userdept: null,//用户详细部门userdept  公司用户为空
          deptname: null,//部门名称deptname  公司用户为空
          firstline: null,//一线经理firstline  公司用户为空
          secondline: null,//二线经理secondline  公司用户为空
          status: null,//用户状态: 0--禁用/冻结  1--正常  2--用户被删除
          organization: null,//公司地址/住址机构
          cdate: null,//创建时间
          ldate: null,//更新时间
          logintimes: null,//登录次数: 记录登录尝试失败次数，登录失败5次就将status改为禁止，联系运维解开
          lastlogintime: null,//最后登录时间: 记录最后登录时间
          accountdate: null,//账户有效期
          area: null,//负责区域
          lucode: null,//更新人编码
          countrytype: null,//1- 国内  /  2- 国外   账户
          fileId: null,
          aaa: null,
          taskid: null,
        },
        bscUserInfoAgentScore:{
          usercode: null,
          customerName1: null, //客户全称1
          staffing:"",
          scale:"",
          qualification:"",
          brandPower:"",
          businessPower:"",
          conclusion:"",
          daquConfirm:"",
          quyuConfirm:"",
        },
        ctList: [{
          field:'',//领域
          channel:'',//渠道
          channelList:[],//渠道
          level:'',//等级
          flType:'',//返利类型
          num: null,
          lianqun:'',
          lianqunList:[],//链群
          showLq : true,
          area:'',
        }],
        levelMap: {},
        changeLevel: {},
        beUpdate: 0,
        beUpdateCom: 0,
        gsValue:"总部",
        contractList:[],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
      fileList:[],
      data: {},
      mf: {
        pageSize: 10,
        pageNo: 1,
        total: 0,
        userCode:null,
      },
      check: {
        checkpassword: ''
      },
      rules1: {
        customerName1:
            [
              {required: true, message: '请填写必填项', trigger: 'blur'},
            ],
        name1:
            [
              {required: true, message: '请填写必填项', trigger: 'blur'},
            ],
        contactMobilePhone:
            [
              {required: true, message: '请填写必填项', trigger: 'blur'},
            ],
        /*  email:[
                        {required: true, message: '请填写必填项', trigger: 'blur'}
                    ],*/
        // 改为是否国内下单权限，，是否国内贸易公司 删除
        // isTrade:
        //     [
        //         {required: true, message: '请填写必填项', trigger: 'blur'},
        //     ],
        companyAddress:
            [
              {required: true, message: '请填写必填项', trigger: 'blur'},
            ],
        country:
            [
              {required: true, message: '请填写必填项', trigger: 'change'},
            ],
        region:
            [
              {required: true, message: '请填写必填项', trigger: 'blur'},
            ],
        phoneNumber:
            [
              {required: true, message: '请填写必填项', trigger: 'blur'},
            ],
        cityStreetRoom:
            [
              {required: true, message: '请填写必填项', trigger: 'blur'},
            ],
        // //纳税人登记号
        taxCode:
            [
              {required: true, message: '请填写必填项', trigger: 'blur'},
            ],
        //银行编号
        bankBranchCode:
            [
              {required: true, message: '请填写必填项', trigger: 'blur'},
            ],
        //银行名称
        bankName:
            [
              {required: true, message: '请填写必填项', trigger: 'blur'},
            ],
        //银行账户号
        accountHolderName:
            [
              {required: true, message: '请填写必填项', trigger: 'blur'},
            ],
        //银行所属国家
        bankCountry:
            [
              {required: true, message: '请填写必填项', trigger: 'blur'},
            ],
        intCommercialTerms:[
          {required: true, message: '请填写国际贸易条件', trigger: 'blur'}
        ],
        intCommercialTerms2:[
          {required: true, message: '请填写必填项', trigger: 'blur'}
        ],
        distributionChannel: [
          {required: true, message: '请填写必填项', trigger: 'blur'},
        ],
        accountDistributeGroup: [
          {required: true, message: '请填写必填项', trigger: 'blur'},
        ],
        // customerGroup1: [
        //     {required: true, message: '请填写必填项', trigger: 'blur'},
        // ],

        customerGroup2: [
          {required: true, message: '请填写必填项', trigger: 'blur'},
        ],
        customerGroup3: [
          {required: true, message: '请填写必填项', trigger: 'blur'},
        ],
        salesRegion: [
          {required: true, message: '请填写必填项', trigger: 'blur'},
        ],
        auditMind1: [
          {required: true, message: '请填写必填项', trigger: 'blur'},
        ],
        companyCode: [
          {required: true, message: '请填写必填项', trigger: 'blur'},
        ],
        upload5: [
          {required: true, message: '请上传资料', trigger: 'blur'},
        ],
        upload6: [
          {required: true, message: '请上传资料', trigger: 'blur'},
        ],
        upload8: [
          {required: true, message: '请上传资料', trigger: 'blur'},
        ],
        licenseNumber:[
          {required: true, message: '请输入许可证号', trigger: 'blur'},
        ],
        agentLevel: [
          {required: true, message: '请填写必填项', trigger: 'blur'},
        ],
        oneLevelAgentName: [
          {required: true, message: '请填写必填项', trigger: 'blur'},
        ],
        upload10: [
          {required: true, message: '请上传资料', trigger: 'blur'},
        ],
        reason: [
          {required: true, message: '请上传资料', trigger: 'blur'},
        ],
      },
      flag: '',
      modelList: [],
      agentType: 1,
      cardName: '总部',
      rules1Index: ['1', '2'],
      reftypeAgent9: '代理商注册-附件',
      fileListAgent9: [],
      idList: [],
      LQcheckList:[],// 选中的链群
      LQList: [],// 渲染链群
      checkLQAfterList: [],// 选中链群之后渲染的列表
      wxList: [],// 外销的列表
      addForm: {},// 链群对象数据
      industry: [{industryName: ''}],
      activeNames: ['1','5']
    }
  },
  created() {
    console.log(this.$route.query, 'query')
    this.getLqList();// 获取链群数据
    this.findAddress();
    ss.Dictservice.listbycategory("sales_region").then(response => {
      console.log(response, "sales_chanle")
      this.qudaoNotMain = response;
      this.qudao = response;
    })
    ss.Dictservice.listbycategory("sales_region_ct").then(response => {
      this.qudaoCt = response;
    })
    ss.Dictservice.listbycategory("sales_region_nd5").then(response => {
      this.qudaoND5 = response;
    })
    this.guanliren = this.$store.getters.hasRole("swyl_admin");
    this.haiwairen = this.$store.getters.hasRole("swyl_waixiaogly,swyl_xiaoshoujl_wx,xiaoshoujingli-waixiao,swyl_haiwailq_xiaoweizhu,hwxsybgly,swyl_xiaoshoujl_yx_wx");
    if (this.$route.query.index === '1') {
      this.refid = this.$util.getUuid();
      this.formLabelAlign1.bscUserInfo.fileId = this.refid;
      this.fileShowFlag = true;
      this.formLabelAlign1.bscUserInfoAgentBasic.country = 'CN';
      this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122001000';
      this.formLabelAlign1.bscUserInfoAgentCompany.sequenceNo = '001';
      this.formLabelAlign1.bscUserInfoAgentCompany.paymentTerm = '0000';
      this.formLabelAlign1.bscUserInfoAgentSell.division = '00';
      this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = 'CNY';
      this.formLabelAlign1.bscUserInfoAgentSell.customerPricingProccess = '1';
      this.formLabelAlign1.bscUserInfoAgentSell.customerSummaryGroup = '1';
      this.formLabelAlign1.bscUserInfoAgentSell.shipCondition = '01';
      this.formLabelAlign1.bscUserInfoAgentSell.custTaxCategory = '1';
      this.formLabelAlign1.bscUserInfoAgentSell.paymentTerms1 = '0000';
      this.formLabelAlign1.OperateType = 'CREATE';
      this.formLabelAlign1.OPERATOR = this._user.username;
      this.formLabelAlign1.bscUserInfoAgentBank.bankCountry = 'CN';
      this.formLabelAlign1.bscUserInfoAgentBasic.partnerFlagSp = '1';
      this.formLabelAlign1.bscUserInfoAgentBasic.partnerFlagBp = '1';
      this.formLabelAlign1.bscUserInfoAgentBasic.partnerFlagPy = '1';
      this.formLabelAlign1.bscUserInfoAgentBasic.partnerFlagSh = '1';

      this.agentType = 2;
      this.isShowMassage = true;
      this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0280';
      this.formLabelAlign1.bscUserInfoAgentBasic.country = 'CN';
      this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122002000';
      this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = 'CNY';
      this.formLabelAlign1.bscUserInfoAgentBasic.accountGroup = '0280';
      this.formLabelAlign1.bscUserInfoAgentBasic.agentType = '1';
      ss.Dictservice.listbycategory("sales_region").then(response => {
        console.log(response, "sales_chanle")
        this.options = response;
      })

    } else if (this.$route.query.index === '2' || this.$route.query.index === '3') {
      if(this.$route.query.isFreezeData === '1'){
        this.isFreezeData = true;
      }
      this.refid = this.$route.query.fileidInfo;
      if (this.$route.query.iszhidanBas == 1){
        this.iszhidan = true;
      }
      if (this.$route.query.companytypeBas == '政府/军工企业'){
        this.isGoverment = true;
      }
      if (this.$store.getters.hasRole("swyl_quyujl,swyl_xiaoshoujl_kangsheng") && !this.$store.getters.hasRole("swyl_agent_update") ) {
        this.isQuyu = true;
      }
      if (this.$store.getters.hasRole("swyl_quyujl") && !this.$store.getters.hasRole("swyl_agent_update") ) {
        this.isQuyuXg = true;
      }
      if (this.$store.getters.hasRole("swyl_xiaoshoujl_kangsheng,swyl_xiaoshoujl_yx,yx_shouhoujl,swyl_xiaoshoujl_hsj,swyl_xiaoshoujl_hh,swyl_xiaoshoujl_honghu") && !this.$store.getters.hasRole("swyl_agent_update") ) {
        this.updateCompany = true;
      }
      this.uploadflag = false;
      this.delflag = false;
      this.fileShowFlag = true;
      if (this.$route.query.agentTypeBas == '3') {
        this.radio = '海外客户';
        this.agentType = 3;
        this.isShowMassage = false;
      } else if (this.$route.query.agentTypeBas == '1') {
        this.radio = '国内客户';
        this.agentType = 1;
        this.isShowMassage = true;
      } else if (this.$route.query.agentTypeBas == '2') {
        this.radio = '上海直销';
        this.agentType = 2;
      }
      if (this.$route.query.permitSell == 5) {
        this.have2 = true;
        this.have3 = true;
      } else if (this.$route.query.permitSell == 2) {
        this.have2 = true;
      } else if (this.$route.query.permitSell == 3) {
        this.have3 = true;
      }
      //如果是解冻,签约资质设置为空,不用查询
      if(this.$route.query.isFreezeData === '1'){
      }else {
        this.queryLevel(this.$route.query.customergroupSell);
        this.queryLevelList(this.$route.query.customergroupSell);
      }
    } else if (this.$route.query.taskid != null) {
      console.log("审批进入页面")
      console.log(this.$store.getters.roles, 'store')
      for (var i = 0; i < this.$store.getters.roles.length; i++) {
        if (this.$store.getters.roles[i].id == 'swyl_dingdgly') {
          this.isShangWei = true;
          agentCopyService.checkWhatChange(this.$route.query.ywid).then(res => {
            this.changedParamList = res;
            if (this.changedParamList.includes("taxCode")) {
              this.taxCode = true;
            }
            if (this.changedParamList.includes("phoneNumber")) {
              this.phoneNumber = true;
            }
            if (this.changedParamList.includes("cityStreetRoom")) {
              this.cityStreetRoom = true;
            }
            if (this.changedParamList.includes("bankBranchCode")) {
              this.bankBranchCode = true;
            }
            if (this.changedParamList.includes("bankName")) {
              this.bankName = true;
            }
            if (this.changedParamList.includes("accountHolderName")) {
              this.accountHolderName = true;
            }
            if (this.changedParamList.includes("bankCountry")) {
              this.bankCountry = true;
            }
            if (this.changedParamList.includes("customerGroup1")) {
              this.customerGroup1 = true;
            }
          })
        }
      }
      var id = this.$route.query.ywid;
      this.instid = this.$route.query.instid;
      this.formLabelAlign1.bscUserInfo.taskid = this.$route.query.taskid;
      agentCopyService.queryOne(id).then(response => {
        console.log(response, 'response1111')
        this.data = response.obj;
        this.uploadflag = false;
        this.delflag = false;
        this.rules = {};
        this.flag = '4';
        this.refid = this.data.fileidInfo;
        this.fileShowFlag = true;
        this.checkDetail();
        console.log(this.refid, 'refid')
        if (response.obj.agentTypeBas == '1') {
          this.radio = '国内客户';
          this.agentType = 1;
          this.isShowMassage = false;
        } else if (response.obj.agentTypeBas == '2') {
          this.radio = '上海直销';
          this.agentType = 2;
          this.isShowMassage = false;
        } else if (response.obj.agentTypeBas == '3') {
          this.radio = '海外客户';
          this.agentType = 3;
          this.isShowMassage = false;
        }
        if (response.obj.permitSell === 5) {
          this.have2 = true;
          this.have3 = true;
        } else if (response.obj.permitSell === 2) {
          this.have2 = true;
        } else if (response.obj.permitSell === 3) {
          this.have3 = true;
        }
        this.queryLevel(response.obj.customergroupSell);
        this.queryLevelList(response.obj.customergroupSell);
      });
    }
    ss.UserService.getUserAuth("18").then(rd=>{
      const array = rd.msg;
      const cardMap = {'1S00':'厚宏','1R60':'康盛','1JC0':'航空温控','0PN0':'海盛杰','44U0':'元析'};
      if(this.$store.getters.hasRole('swyl_admin')){

      }else {
        this.cardName = array.find(code => code in cardMap) ? cardMap[array.find(code => code in cardMap)] : '总部';
        this.formLabelAlign1.gsValue = this.cardName;
        if(this.formLabelAlign1.gsValue!=='总部'){
          // this.getLianqunTickct([e.name])
          this.gnsc = false;
          // this.checkLQAfterList = [];
          let map = new Map();
          for (let item of this.LQList) {
            if (!map.has(item.lianqun)) {
              map.set(item.lianqun, item);
            }
          }
          this.LQcheckList = [e.name]
          this.checkLQAfterList = [...map.values()].filter(item => this.LQcheckList.includes(item.lianqun))
        }else {
          this.gnsc = true;
        }
        console.log("this.gnsc",this.gnsc);
      }
    })
  },

  beforeRouteLeave(to,from,next){
    if(to.path=='/agent/agentCopy' && from.path == '/agentUpdateShangWei'){
      to.meta.keepAlive = true;
    }else{
      to.meta.keepAlive = false;
    }
    next();
  },
  methods: {
    findAddress() {
      ss.SignService.selectAddress().then(response => {
        this.addli = response;
      })
    },
    //表格
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    updateShangWei(formName,isF){
      if(isF == 1){
        this.formLabelAlign1.bscUserInfoAgentBasic.isFreezeData = '1'
      }else {
        this.formLabelAlign1.bscUserInfoAgentBasic.isFreezeData = '0'
      }
      if(this.isExpandAuthority){
        this.formLabelAlign1.bscUserInfoAgentBasic.isExpandAuthority = '1';
      }else{
        this.formLabelAlign1.bscUserInfoAgentBasic.isExpandAuthority = '0';
      }
      //如果是91码传0210
      if(this.formLabelAlign1.bscUserInfo.usercode.startsWith('91')){
        this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0210';
        this.formLabelAlign1.bscUserInfoAgentBasic.accountGroup = '0210';
      }
      this.formLabelAlign1.bscUserInfoAgentBasic.instidThaw = this.instidThaw;
      var ctList = this.formLabelAlign1.ctList;

      for(var i=0;i<ctList.length;i++){
        var qudaoL = this.getQudaoL(ctList[i].channelList);
        this.formLabelAlign1.ctList[i].channel = qudaoL;
      }
      //处理一下传统的签约链群
      console.log(this.formLabelAlign1.changeLevel,"变了什么")
      if (this.agentType == 3 && this.formLabelAlign1.bscUserInfoAgentBasic.isTrade != 1) {
        this.index1 = ['c','d','1','2','4'];
      }
      console.log(this.index1,"校验的啥");
      var flag = 0;
/*      for (var i = 0; i < this.index1.length; i++) {
        this.ind = this.index1[i];
        var form = formName + this.ind;
        this.$refs[form].validate((valid) => {
          if (valid) {
            console.log('submit!');
          } else {
            flag = flag + 1;
            return false;
          }
        });
      }*/
      if (flag !== 0) {
        return false;
      }
      if (this.have2 === true && this.have3 === false) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 2;
      } else if (this.have2 === false && this.have3 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 3;
      } else if (this.have2 === true && this.have3 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 5;
      } else if (this.have2 === false && this.have3 === false) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 0;
      }
      if (this.formLabelAlign1.bscUserInfoAgentBasic.isTrade == 1 || this.agentType == 1 || this.agentType == 2) {
        if (this.formLabelAlign1.bscUserInfoAgentBasic.taxCode == '') {
          this.$msg.msge("国内客户以及贸易公司的纳税人登记号不能为空！");
          return false;
        }
      }
      if (this.$store.getters.hasRole("swyl_quyujl,swyl_xiaoshoujl_kangsheng,swyl_xiaoshoujl_yx,yx_shouhoujl") && !this.$store.getters.hasRole("swyl_agent_update") && this.chflag == 0 && this.companyCodeNumFlag != 0) {
        this.$msg.msge("签约公司请点击扩展公司范围！");
        return false;
      }
      if (this.$store.getters.hasRole("swyl_quyujl,swyl_xiaoshoujl_kangsheng,swyl_xiaoshoujl_yx,yx_shouhoujl") && !this.$store.getters.hasRole("swyl_agent_update") && this.chflag == 0 && this.companyCodeNumFlag != 0) {
        this.$msg.msge("您没有进行任何修改！");
        return false;
      }
      if (this.agentType != 3) {
        if (!this.formLabelAlign1.bscUserInfoAgentBasic.contactCity
            || this.formLabelAlign1.bscUserInfoAgentBasic.contactCity == '') {
          this.$msg.msge("请选择所在城市！");
          return false;
        }
      }
      this.formLabelAlign1.bscUserInfo.fileId = this.refid;
      if (this.agentType == 1) {
        this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0280';
        this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122002000';
        this.formLabelAlign1.bscUserInfoAgentBasic.accountGroup = '0280';
        this.formLabelAlign1.bscUserInfoAgentBasic.agentType = '1';
        this.formLabelAlign1.bscUserInfoAgentBasic.currencyCode = 'CNY'
      } else if (this.agentType == 2) {
        // this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0210';
        // this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122001000';
        // this.formLabelAlign1.bscUserInfoAgentBasic.accountGroup = '0210';
        this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0280';
        this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122002000';
        this.formLabelAlign1.bscUserInfoAgentBasic.accountGroup = '0280';
        this.formLabelAlign1.bscUserInfoAgentBasic.agentType = '2';
      } else if (this.agentType == 3) {
        this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0260';
        this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122002000';
        this.formLabelAlign1.bscUserInfoAgentBasic.accountGroup = '0260';
        this.formLabelAlign1.bscUserInfoAgentBasic.agentType = '3';
        if(!this.isExpandAuthority){
          this.formLabelAlign1.bscUserInfoAgentBasic.region = this.formLabelAlign1.bscUserInfoAgentBasic.country;
        } else {
          this.formLabelAlign1.bscUserInfoAgentBasic.region = this.formLabelAlign1.bscUserInfoAgentBasic.region;
        }
        this.formLabelAlign1.bscUserInfo.area = this.formLabelAlign1.bscUserInfoAgentBasic.country
        // this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan = '1';
      }
      this.formLabelAlign1.bscUserInfo.username = this.formLabelAlign1.bscUserInfoAgentBasic.customerName1
      if (this.have6858 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.have6858 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.have6858 = 0;
      }
      if (this.have6840 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.have6840 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.have6840 = 0;
      }
      if (this.have6854 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.have6854 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.have6854 = 0;
      }
      if (this.have1101 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.have1101 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.have1101 = 0;
      }
      if (this.have2214 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.have2214 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.have2214 = 0;
      }
      if (this.have2215 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.have2215 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.have2215 = 0;
      }
      if (this.have2216 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.have2216 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.have2216 = 0;
      }
      if (this.havepolicy2017 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.havepolicy2017 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.havepolicy2017 = 0;
      }
      console.log(this.formLabelAlign1.bscUserInfoAgentBasic.isTrade,"isTrade");
      this.formLabelAlign1.bscUserInfoAgentBasic.isBlood = this.isBlood ? '1':'0'

      var jsonObj = this.lianqunList
      var jStr = '';
      for(var item in jsonObj){
        jStr += jsonObj[item]+",";
      }
      this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = jStr.substring(0, jStr.lastIndexOf(','))

      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3 = this.qudaos
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain = this.qudaosNotMain
      this.formLabelAlign1.bscUserInfoAgentSell.salesCity = this.citys
      this.formLabelAlign1.bscUserInfoAgentBasic.refidxg = this.refidxg

      this.LQcheckList = this.LQcheckList.filter(item=>item!='X05' || item!='X06' || item!=null);
      console.log(this.LQcheckList,"this.LQcheckListthis.LQcheckList")

      this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategoryNew = this.LQcheckList.join(',')
      let levelMapNew = JSON.parse(JSON.stringify(this.formLabelAlign1.levelMap))

      let levelObjNew = Object.assign({},levelMapNew,this.addForm);

      for (let key in levelObjNew) {
        if(key == 'ct') {

        } else {
          if(Array.isArray(levelObjNew[key])) {
            console.log(levelObjNew[key],"是数组")
            levelObjNew[key] = levelObjNew[key].join()
          }
        }
      }
      this.formLabelAlign1.levelMap = levelObjNew;
      console.log(this.formLabelAlign1,"提交修改数据")

      if(this.updateCompany){
        agentCopyService.updateCompanyService(this.formLabelAlign1).then(response => {
          if (response.f){
            this.$message({
              type: "success",
              message: response.msg
            });
            this.$router.push("/agent/agentCopy")
          } else {
            this.$message({
              type: "error",
              message: response.msg
            });
          }
        })
        return ;
      }

      var isDs = false;
      //判断地市直营商
      for(var i=0;i<this.formLabelAlign1.ctList.length;i++){
        if(this.formLabelAlign1.ctList[i].flType == '06' ){
          isDs = true;
        }
      }
      if(isDs){
        this.$msg.confirm("是否确认签约合同为地市直营商?", () => {
          agentCopyService.updateShangWei(this.formLabelAlign1).then(response => {
            if (response.f){
              this.$message({
                type: "success",
                message: response.msg
              });
              this.$router.push("/agent/agentCopy")
            } else {
              this.$message({
                type: "error",
                message: response.msg
              });
            }
          })
        });
      }else {
        agentCopyService.updateShangWei(this.formLabelAlign1).then(response => {
          if (response.f){
            this.$message({
              type: "success",
              message: response.msg
            });
            this.$router.push("/agent/agentCopy")
          } else {
            this.$message({
              type: "error",
              message: response.msg
            });
          }
        })
      }
    },

    updateAgentJbxn(formName){
      if(this.isExpandAuthority){
        this.formLabelAlign1.bscUserInfoAgentBasic.isExpandAuthority = '1';
      }else{
        this.formLabelAlign1.bscUserInfoAgentBasic.isExpandAuthority = '0';
      }
      //如果是91码传0210
      if(this.formLabelAlign1.bscUserInfo.usercode.startsWith('91')){
        this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0210';
        this.formLabelAlign1.bscUserInfoAgentBasic.accountGroup = '0210';
      }
      this.formLabelAlign1.bscUserInfoAgentBasic.instidThaw = this.instidThaw;
      console.log(this.formLabelAlign1.changeLevel,"变了什么")
      console.log(this.index2,"校验的啥");
      var flag = 0;
      for (var i = 0; i < this.index2.length; i++) {
        this.ind = this.index2[i];
        var form = formName + this.ind;
        this.$refs[form].validate((valid) => {
          if (valid) {
            console.log('submit!');
          } else {
            flag = flag + 1;
            return false;
          }
        });
      }
      if (flag !== 0) {
        return false;
      }
      if (this.have2 === true && this.have3 === false) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 2;
      } else if (this.have2 === false && this.have3 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 3;
      } else if (this.have2 === true && this.have3 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 5;
      } else if (this.have2 === false && this.have3 === false) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 0;
      }
      if (this.formLabelAlign1.bscUserInfoAgentBasic.isTrade == 1 || this.agentType == 1 || this.agentType == 2) {
        if (this.formLabelAlign1.bscUserInfoAgentBasic.taxCode == '') {
          this.$msg.msge("国内客户以及贸易公司的纳税人登记号不能为空！");
          return false;
        }
      }
      if (this.$store.getters.hasRole("swyl_quyujl,swyl_xiaoshoujl_kangsheng,swyl_xiaoshoujl_yx,yx_shouhoujl") && !this.$store.getters.hasRole("swyl_agent_update") && this.chflag == 0 && this.companyCodeNumFlag != 0) {
        this.$msg.msge("您没有进行任何修改！");
        return false;
      }
      if (this.agentType != 3) {
        if (!this.formLabelAlign1.bscUserInfoAgentBasic.contactCity
                || this.formLabelAlign1.bscUserInfoAgentBasic.contactCity == '') {
          this.$msg.msge("请选择所在城市！");
          return false;
        }
      }
      this.formLabelAlign1.bscUserInfo.fileId = this.refid;
      if (this.agentType == 1) {
        this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0280';
        this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122002000';
        this.formLabelAlign1.bscUserInfoAgentBasic.accountGroup = '0280';
        this.formLabelAlign1.bscUserInfoAgentBasic.agentType = '1';
        this.formLabelAlign1.bscUserInfoAgentBasic.currencyCode = 'CNY'
      } else if (this.agentType == 2) {
        this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0280';
        this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122002000';
        this.formLabelAlign1.bscUserInfoAgentBasic.accountGroup = '0280';
        this.formLabelAlign1.bscUserInfoAgentBasic.agentType = '2';
      } else if (this.agentType == 3) {
        this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0260';
        this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122002000';
        this.formLabelAlign1.bscUserInfoAgentBasic.accountGroup = '0260';
        this.formLabelAlign1.bscUserInfoAgentBasic.agentType = '3';
        if(!this.isExpandAuthority){
          this.formLabelAlign1.bscUserInfoAgentBasic.region = this.formLabelAlign1.bscUserInfoAgentBasic.country;
        } else {
          this.formLabelAlign1.bscUserInfoAgentBasic.region = this.formLabelAlign1.bscUserInfoAgentBasic.region;
        }
        this.formLabelAlign1.bscUserInfo.area = this.formLabelAlign1.bscUserInfoAgentBasic.country
      }
      this.formLabelAlign1.bscUserInfo.username = this.formLabelAlign1.bscUserInfoAgentBasic.customerName1
      if (this.have6858 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.have6858 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.have6858 = 0;
      }
      if (this.have6840 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.have6840 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.have6840 = 0;
      }
      if (this.have6854 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.have6854 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.have6854 = 0;
      }
      if (this.have1101 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.have1101 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.have1101 = 0;
      }
      if (this.have2214 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.have2214 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.have2214 = 0;
      }
      if (this.have2215 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.have2215 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.have2215 = 0;
      }
      if (this.have2216 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.have2216 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.have2216 = 0;
      }
      if (this.havepolicy2017 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.havepolicy2017 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.havepolicy2017 = 0;
      }
      console.log(this.formLabelAlign1.bscUserInfoAgentBasic.isTrade,"isTrade");
      this.formLabelAlign1.bscUserInfoAgentBasic.isBlood = this.isBlood ? '1':'0'

      var jsonObj = this.lianqunList
      var jStr = '';
      for(var item in jsonObj){
        jStr += jsonObj[item]+",";
      }
      this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = jStr.substring(0, jStr.lastIndexOf(','))

      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3 = this.qudaos
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain = this.qudaosNotMain
      this.formLabelAlign1.bscUserInfoAgentSell.salesCity = this.citys
      this.formLabelAlign1.bscUserInfoAgentBasic.refidxg = this.refidxg

      console.log(this.LQcheckList,"this.LQcheckListthis.LQcheckList")
      console.log(this.formLabelAlign1,"提交修改数据")

      agentCopyService.updateAgentJbxn(this.formLabelAlign1).then(response => {
        if (response.f){
          this.$message({
            type: "success",
            message: response.msg
          });
        } else {
          this.$message({
            type: "error",
            message: response.msg
          });
        }
      })
    },
    expandShangWei(formName) {
      this.formLabelAlign1.bscUserInfo.fileId = this.refid;
      if(this.isExpandAuthority){
        this.formLabelAlign1.bscUserInfoAgentBasic.isExpandAuthority = '1';
      }else{
        this.formLabelAlign1.bscUserInfoAgentBasic.isExpandAuthority = '0';
      }
      console.log(this.formLabelAlign1,"/////")
      console.log(this.formLabelAlign1.changeLevel,"变了什么")
      if (this.agentType == 3 && this.formLabelAlign1.bscUserInfoAgentBasic.isTrade != 1) {
        this.index1 = ['c','d','1','2','4'];
      }
      console.log(this.index1,"校验的啥");
 /*     var flag = 0;
      for (var i = 0; i < this.index1.length; i++) {
        this.ind = this.index1[i];
        var form = formName + this.ind;
        this.$refs[form].validate((valid) => {
          if (valid) {
            console.log('submit!');
          } else {
            flag = flag + 1;
            return false;
          }
        });
      }*/
   /*   if (flag !== 0) {
        return false;
      }*/
      if (this.have2 === true && this.have3 === false) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 2;
      } else if (this.have2 === false && this.have3 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 3;
      } else if (this.have2 === true && this.have3 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 5;
      } else if (this.have2 === false && this.have3 === false) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 0;
      }
      var ctList = this.formLabelAlign1.ctList;
      for(var i=0;i<ctList.length;i++){
        var qudaoL = this.getQudaoL(ctList[i].channelList);
        this.formLabelAlign1.ctList[i].channel = qudaoL;
        var lianqunL = this.getQudaoL(ctList[i].lianqunList);
        this.formLabelAlign1.ctList[i].lianqun = lianqunL;
      }
      if (this.formLabelAlign1.bscUserInfoAgentBasic.isTrade == 1 || this.agentType == 1 || this.agentType == 2) {
        if (this.formLabelAlign1.bscUserInfoAgentBasic.taxCode == '') {
          this.$msg.msge("国内客户以及贸易公司的纳税人登记号不能为空！");
          return false;
        }
      }
      /*    if (this.$store.getters.hasRole("swyl_quyujl,swyl_xiaoshoujl_kangsheng") && !this.$store.getters.hasRole("swyl_agent_update") && this.chflag == 0) {
                  this.$msg.msge("您没有进行任何修改！");
                  return false;
                }*/
      if (this.agentType != 3) {
        if (!this.formLabelAlign1.bscUserInfoAgentBasic.contactCity
            || this.formLabelAlign1.bscUserInfoAgentBasic.contactCity == '') {
          this.$msg.msge("请选择所在城市！");
          return false;
        }
      }
      this.formLabelAlign1.bscUserInfo.fileId = this.refid;
      if (this.agentType == 1) {
        this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0280';
        this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122002000';
        this.formLabelAlign1.bscUserInfoAgentBasic.accountGroup = '0280';
        this.formLabelAlign1.bscUserInfoAgentBasic.agentType = '1';
        this.formLabelAlign1.bscUserInfoAgentBasic.currencyCode = 'CNY'
      } else if (this.agentType == 2) {
        // this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0210';
        // this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122001000';
        // this.formLabelAlign1.bscUserInfoAgentBasic.accountGroup = '0210';
        this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0280';
        this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122002000';
        this.formLabelAlign1.bscUserInfoAgentBasic.accountGroup = '0280';
        this.formLabelAlign1.bscUserInfoAgentBasic.agentType = '2';
      } else if (this.agentType == 3) {
        this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0260';
        this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122002000';
        this.formLabelAlign1.bscUserInfoAgentBasic.accountGroup = '0260';
        this.formLabelAlign1.bscUserInfoAgentBasic.agentType = '3';
        if(!this.isExpandAuthority){
          this.formLabelAlign1.bscUserInfoAgentBasic.region = this.formLabelAlign1.bscUserInfoAgentBasic.country;
        } else {
          this.formLabelAlign1.bscUserInfoAgentBasic.region = this.formLabelAlign1.bscUserInfoAgentBasic.region;
        }
        this.formLabelAlign1.bscUserInfo.area = this.formLabelAlign1.bscUserInfoAgentBasic.country
        // this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan = '1';
      }
      this.formLabelAlign1.bscUserInfo.username = this.formLabelAlign1.bscUserInfoAgentBasic.customerName1
      if (this.have6858 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.have6858 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.have6858 = 0;
      }
      if (this.have6840 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.have6840 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.have6840 = 0;
      }
      if (this.have6854 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.have6854 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.have6854 = 0;
      }
      if (this.have1101 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.have1101 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.have1101 = 0;
      }
      if (this.have2214 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.have2214 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.have2214 = 0;
      }
      if (this.have2215 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.have2215 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.have2215 = 0;
      }
      if (this.have2216 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.have2216 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.have2216 = 0;
      }
      if (this.havepolicy2017 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.havepolicy2017 = 1;
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.havepolicy2017 = 0;
      }
      console.log(this.formLabelAlign1.bscUserInfoAgentBasic.isTrade,"isTrade");
      this.formLabelAlign1.bscUserInfoAgentBasic.isBlood = this.isBlood ? '1':'0'

      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3 = this.qudaos
      this.formLabelAlign1.bscUserInfoAgentSell.salesCity = this.citys
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain = this.qudaosNotMain
      this.formLabelAlign1.bscUserInfo.fileId = this.refid;

      if(this.$store.getters.hasRole("swyl_quyujl,swyl_xiaoshoujl_kangsheng,swyl_xiaoshoujl_yx,yx_shouhoujl") && !this.$store.getters.hasRole("swyl_agent_update")){
        this.formLabelAlign1.bscUserInfoAgentBasic.refidxg = this.refidxg;
      }else {
        this.formLabelAlign1.bscUserInfoAgentBasic.refidxg = null;
      }
      this.formLabelAlign1.bscUserInfoAgentBasic.refidxg = this.refidxg
      agentCopyService.expandShangWei(this.formLabelAlign1).then(response => {
        if (response.f){
          this.$message({
            type: "success",
            message: response.msg
          });
          this.$router.push("/agent/agentCopy")
        } else {
          this.$message({
            type: "error",
            message: response.msg
          });
        }
      })
    },
    chooseZhiDan() {
      console.log(" this.chflag++;", this.chflag)
      if (this.isZhiDan) {
        this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan = 1;
        if (this.formLabelAlign1.ctList.length>=1) {
          for(var item in this.formLabelAlign1.ctList){
            if(this.formLabelAlign1.ctList[item].level != null && this.formLabelAlign1.ctList[item].channel != null
                && this.formLabelAlign1.ctList[item].level != '' && this.formLabelAlign1.ctList[item].channel != ''
            ){
              this.formLabelAlign1.ctList[item].level = '04';
            }
          }
          this.formLabelAlign1.levelMap['ct'] = this.ND6Level;
          this.formLabelAlign1.changeLevel['ct'] = this.ND6Level;
        }
        this.chflag++;
      } else {
        this.isGoverment = false;
        this.formLabelAlign1.bscUserInfoAgentBasic.companytype = "";
        this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan = 0;
        if (this.formLabelAlign1.ctList.length>=1) {
          for(var item in this.formLabelAlign1.ctList){
            if(this.formLabelAlign1.ctList[item].level != null && this.formLabelAlign1.ctList[item].channel != null
                && this.formLabelAlign1.ctList[item].level != '' && this.formLabelAlign1.ctList[item].channel != ''
            ){
              if (this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel == '2') {
                this.formLabelAlign1.ctList[item].level = '05';
              } else if (this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel == '3') {
                this.formLabelAlign1.ctList[item].level = '02';
                this.formLabelAlign1.ctList[item].flType= '';
              } else if (this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel == '5') {
                this.formLabelAlign1.ctList[item].flType= '05';
              } else if (this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel == '6') {
                this.formLabelAlign1.ctList[item].flType= '06';
              } else {
                this.formLabelAlign1.ctList[item].level = '01';
                this.formLabelAlign1.ctList[item].flType= '01';
              }
              this.formLabelAlign1.levelMap['ct'] = this.ctLevel;
              this.formLabelAlign1.changeLevel['ct'] = this.ctLevel;
            }
          }
        }
        this.chflag++;
      }
      console.log(" this.chflag++;", this.chflag)
    },
    //是否开通海外直单权限
    chooseAddAbroad(){
      if (this.isExpandAuthority) {
        this.formLabelAlign1.bscUserInfoAgentBasic.isExpandAuthority = 1;
        this.isExpandAuthority = true
        console.log("开通权限")
      } else {
        this.formLabelAlign1.bscUserInfoAgentBasic.isExpandAuthority = 0;
        this.isExpandAuthority = false
        console.log("暂不开通")
      }
    },
    //是否开通国内下单权限  仅针对海外客户
    chooseDomestic(){
      if (this.isExpandAuthority ) {
        this.isShowByHw = true;
        this.formLabelAlign1.bscUserInfoAgentBasic.isTrade = 1
        this.formLabelAlign1.bscUserInfoAgentBasic.isExpandAuthority = 1;
        console.log("水水水水")
      } else {
        this.isShowByHw = false;
        this.formLabelAlign1.bscUserInfoAgentBasic.isTrade = 0
        this.formLabelAlign1.bscUserInfoAgentBasic.isExpandAuthority = 0;
        console.log("呃呃呃呃")
      }
    },
    chooseGoverment() {
      if (this.isGoverment) {
        this.formLabelAlign1.bscUserInfoAgentBasic.companytype = "政府/军工企业";
      } else {
        this.formLabelAlign1.bscUserInfoAgentBasic.companytype = "";
      }
    },
    //是否开通体外试剂
    chooseIVD(){
      if (this.haveThree6840) {
        this.formLabelAlign1.bscUserInfoAgentSell.haveThree6840 = 1;
        console.log("包含")
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.haveThree6840 = 0;
        console.log("不包含III类6840")
      }
    },
    queryLevel(v) {
      agentCopyService.queryLevel(v).then(response => {
        console.log(response, 'levelmap')
        if (response.ct != undefined) {
          this.checkedlevels.push("传统产品");
          this.ctLevel = response.ct;
          this.ct = true;
          if (this.data.iszhidanBas == 1 &&  this.ctLevel != '' && this.ctLevel != '04') {
            this.ctLevel = '';
          }else {
            this.formLabelAlign1.levelMap['ct'] = this.ctLevel;
          }
        }
      })
    },

    queryLevelList(v){
      agentCopyService.queryLevelList(v).then(response => {
        console.log(response, 'levelmap11111111')
        let filteredObject = {};
        let p = new Set(Object.keys(response));
        let blacklist = ['ct'];
        blacklist.forEach(a => p.delete(a));
        [...p].forEach(k => filteredObject[k] = response[k]);
        this.addForm = filteredObject;
        if (response.ct != undefined) {
          this.checkedlevels.push("传统产品");
          if(response.ct.length >= 1){
            this.formLabelAlign1.ctList = response.ct;
            this.lianqunListCt.push("ct");
            this.getLianqunTickct(this.lianqunListCt);
            this.chflag--;
            for(var item in this.formLabelAlign1.ctList){
              /*  if(this.formLabelAlign1.ctList[item].lianqun != null && this.formLabelAlign1.ctList[item].lianqun != ""){
                        var m  = this.formLabelAlign1.ctList[item].lianqun.split(',');
                        this.formLabelAlign1.ctList[item].lianqunList = m
                      } else{
                        this.formLabelAlign1.ctList[item].lianqunList = []
                      }*/
              if(null == this.formLabelAlign1.ctList[item].level || "" == this.formLabelAlign1.ctList[item].level){
                this.formLabelAlign1.ctList[item].channelList = []
              }else {
                var m = this.formLabelAlign1.ctList[item].channel.split(',');
                console.log("mmmm",m)
                this.fields.push(this.formLabelAlign1.ctList[item].field);
                if (m.length <= 0 || null == m || "" == m) {
                  this.formLabelAlign1.ctList[item].channelList = [];
                }else {
                  this.formLabelAlign1.ctList[item].channelList = m;
                }
              }
            }
            this.ct = true;
            this.getQudaoCt();
            this.chflag--;
            this.formLabelAlign1.levelMap['ct'] = this.ctLevel;
          }
        }
        console.log(response, 'levelmap2222222222')
      })
      this.formLabelAlign1.beUpdate--;
    },
    changeFlag(obj,type) {
      this.chflag++;
      this.formLabelAlign1.beUpdate++;
    },
    choose2017(){
      if (this.havepolicy2017) {
        this.formLabelAlign1.bscUserInfoAgentSell.havepolicy2017 = 1;
        console.log("包含2017版分类目录")
      } else {
        this.formLabelAlign1.bscUserInfoAgentSell.havepolicy2017 = 0;
        console.log("不包含2017版分类目录")
      }
    },
    changeArea(query) {
      //如果是内销
      if(this.agentType != '3'){
        console.log(query);
        let areaList = query;
        var areas = [];
        for(var i=0;i<areaList.length;i++){
          areas.push(areaList[i].refid)
        }
        console.log(areas);
        ss.UserService.getCityByArea(areas).then(rd=>{
          console.log(rd);
          this.salesCity = rd.msg;
        })
        this.chflag++;
        this.formLabelAlign1.beUpdate++;
      }
    },
    changeCom(obj,type) {
      this.chflag++;
      this.formLabelAlign1.beUpdateCom++;
    },
    ctSelect() {
      this.formLabelAlign1.beUpdate++;
      this.formLabelAlign1.levelMap['ct'] = this.ctLevel;
      this.formLabelAlign1.changeLevel['ct'] = this.ctLevel;
      this.chflag++;
    },
    fieldSelect(index){
      this.formLabelAlign1.beUpdate++;
      this.formLabelAlign1.ctList[index].channelList = '';
      this.fields = [];
      //循环一遍是不是选择了领域
      //如果不是null就不需要在显示链群了
      var isF = true;
      //获取签约的领域
      var ly = []
      for(var i=0;i<this.formLabelAlign1.ctList.length;i++){
        if(i != index){
          ly.push(this.formLabelAlign1.ctList[i].field);
        }
      }
      console.log("ly",ly)
      console.log("this.formLabelAlign1.ctList[index]",this.formLabelAlign1.ctList[index].field)
      if(ly.includes(this.formLabelAlign1.ctList[index].field)){
        this.formLabelAlign1.ctList[index].showLq = false;
      }else {
        this.formLabelAlign1.ctList[index].showLq = true;
      }
      console.log(this.formLabelAlign1.ctList[index].showLq);
      //更新领域的时候
      for(var i=0;i<this.formLabelAlign1.ctList.length;i++){
        if(this.formLabelAlign1.ctList[i].field != null && this.formLabelAlign1.ctList[i].field != ''){
          this.fields.push(this.formLabelAlign1.ctList[i].field);
        }
      }
      //进行强制数据渲染
      this.$forceUpdate();
      this.chflag++;
    },
    getLianqunTickct(query){
      this.formLabelAlign1.beUpdate++;
      console.log("lianquns",query);
      if(query.indexOf("ct") != -1){
        this.isCt = true;
      }else {
        this.isCt = false;
        this.formLabelAlign1.ctList =  [{
          field:'',//领域
          channel:'',//渠道
          channelList:[],//渠道
          level:'',//等级
          num: null,
          lianqun:'',
          lianqunList:[],//链群
        }]
      }
      this.chflag++;
    },
    handleCheckAllChange(val) {
      console.log(val, '全选')
      if (val) {
        this.ct = true;
      } else {
        this.ct = false;
      }
      this.checkedlevels = val ? this.levels : [];
      this.isIndeterminate = false;

    },
    handleCheckedCitiesChange(value) {
      console.log(value, '级别分类')
      this.ct = false;
      this.formLabelAlign1.levelMap = {};
      for (var i = 0; i < value.length; i++) {
        if (value[i] == '传统产品') {
          this.ct = true;
          this.formLabelAlign1.levelMap['ct'] = this.ctLevel;
        }
      }
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.levels.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.levels.length;
    },
    choseObj2(obj) {
      console.log(obj)
      this.showflag2 = false;
      if (obj.zhenobj && obj.zhenobj.name) {
        this.formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom = obj.shengobj.name + ' ' + obj.shiobj.name + ' ' + obj.quobj.name + ' ' + obj.zhenobj.name + ' ' + obj.addrdetail;
      } else {
        this.formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom = obj.shengobj.name + ' ' + obj.shiobj.name + ' ' + obj.quobj.name + ' ' + obj.addrdetail;
      }
    },
    viewpress() {
      this.showhistory = true;
    },
    fileBack1(v) {
      console.log(v)
      this.formLabelAlign1.bscUserInfoAgentBasic.upload5 = v.length;
    },
    fileBack2(v) {
      console.log(v)
      this.formLabelAlign1.bscUserInfoAgentBasic.upload6 = v.length;
    },
    fileBack3(v) {
      console.log(v)
      this.formLabelAlign1.bscUserInfoAgentBasic.upload8 = v.length;
    },
    fileBack10(v) {
      console.log(v)
      console.log("beUpdate",this.formLabelAlign1.beUpdate);
      console.log("chflag",this.chflag);
      this.formLabelAlign1.bscUserInfoAgentBasic.upload10 = v.length;
    },
    handleIconClick() {
      this.showflag = true;
    },
    handleIconClick2() {
      this.showflag2 = true;
    },
    choseObj(obj) {
      console.log(obj)
      this.showflag = false;
      if (obj.zhenobj && obj.zhenobj.name) {
        this.formLabelAlign1.bscUserInfoAgentCompany.mailaddress = obj.shengobj.name + ' ' + obj.shiobj.name + ' ' + obj.quobj.name + ' ' + obj.zhenobj.name + ' ' + obj.addrdetail;
      } else {
        this.formLabelAlign1.bscUserInfoAgentCompany.mailaddress = obj.shengobj.name + ' ' + obj.shiobj.name + ' ' + obj.quobj.name + ' ' + obj.addrdetail;
      }
    },
    changeType(v) {
      if (v === '海外客户') {
        this.agentType = 3;
        this.isShowMassage = false;
        this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0260';
        // this.formLabelAlign1.bscUserInfoAgentBasic.country = '';
        this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122002000';
        this.formLabelAlign1.bscUserInfoAgentBasic.accountGroup = '0260';
        this.formLabelAlign1.bscUserInfoAgentBasic.agentType = '3';
        this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan = '1';
        this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = '';
      } else if (v === '上海直销') {
        this.agentType = 2;
        this.isShowMassage = true;
        this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0280';
        // this.formLabelAlign1.bscUserInfoAgentBasic.country = 'CN';
        this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122002000';
        this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = 'CNY';
        this.formLabelAlign1.bscUserInfoAgentBasic.accountGroup = '0280';
        this.formLabelAlign1.bscUserInfoAgentBasic.agentType = '2';
      } else if (v === '国内客户') {
        this.agentType = 1;
        this.isShowMassage = true;
        this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0280';
        // this.formLabelAlign1.bscUserInfoAgentBasic.country = 'CN';
        this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122002000';
        this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = 'CNY';
        this.formLabelAlign1.bscUserInfoAgentBasic.accountGroup = '0280';
        this.formLabelAlign1.bscUserInfoAgentBasic.agentType = '1';
        this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = '';
      }
    },
    //通过审批按钮功能
    update() {
      if (!this.isShangWei) {
        var flag = 0;
        for (var i = 0; i < this.rules1Index.length; i++) {
          this.ind = this.rules1Index[i];
          var form = 'shenheRules' + this.ind;
          console.log(form)
          this.$refs[form].validate((valid) => {
            if (valid) {

            } else {
              flag = flag + 1;
              return false;
            }
          });
        }
        if (flag !== 0) {
          return false;
        }
        console.log(this.formLabelAlign1, 'this.formLabelAlign1this.formLabelAlign1')
      }
      this.formLabelAlign1.bscUserInfo.aaa = 1;
      this.formLabelAlign1.bscUserInfo.fileId = this.refid;
      this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = this.currencyCode;
      agentCopyService.agentPass(this.formLabelAlign1).then(response => {
        if (response.f) {
          this.$msg.alerts("提交成功！", () => {
            //刷新右上角的代办个数
            this.$store.dispatch("searchTasktotal")
            //跳转回系统的代办列表
            this.$router.push({path: '/personal/dealCenter'})
          })
        }
      })
    },
    //驳回按钮功能
    reject(data) {
      this.formLabelAlign1.bscUserInfo.aaa = 2;
      agentCopyService.agentPass(this.formLabelAlign1);
      var defaultpage = this._user.defaultpage;
      this.$router.push({path: defaultpage});
      // this.formLabelAlign1.bscUserInfo.status = '5';
    },
    //经销商查看功能对应展示数据功能
    checkDetail() {
      this.formLabelAlign1.bscUserInfo.usercode = this.data.usercodeInfo
      if(this.data.usercodeBas) {
        this.formLabelAlign1.bscUserInfoAgentBasic.usercode = this.data.usercodeBas
      }else {
        this.formLabelAlign1.bscUserInfoAgentBasic.usercode = this.data.usercodeInfo
      }
      this.formLabelAlign1.bscUserInfoAgentBank.usercode = this.data.usercodeBank
      this.formLabelAlign1.bscUserInfoAgentCompany.usercode = this.data.usercodeCom
      this.formLabelAlign1.bscUserInfoAgentSell.usercode = this.data.usercodeSell

      this.formLabelAlign1.bscUserInfo.username = this.data.usernameInfo
      this.formLabelAlign1.bscUserInfo.password = this.data.passwordInfo
      if(this.data.customername1Bas) {
        this.formLabelAlign1.bscUserInfoAgentBasic.customerName1 = this.data.customername1Bas
      }else {
        this.formLabelAlign1.bscUserInfoAgentBasic.customerName1 = this.data.usernameInfo
      }
      if (this.data.scaleBas !== undefined) {
        // this.formLabelAlign1.bscUserInfoAgentBasic.scale = this.data.scaleBas.toString()
        this.formLabelAlign1.bscUserInfoAgentBasic.scale = this.data.scaleBas
      }
      if (this.data.companyaddressBas && this.data.companyaddressBas != '') {
        this.formLabelAlign1.bscUserInfoAgentBasic.companyAddress = this.data.companyaddressBas
      } else {
        this.formLabelAlign1.bscUserInfoAgentBasic.companyAddress = this.data.streetroomBas
      }
      this.formLabelAlign1.bscUserInfoAgentBasic.isTrade = this.data.isTradeBas

      this.formLabelAlign1.bscUserInfoAgentBasic.postalCode = this.data.postalcodeBas
      this.formLabelAlign1.bscUserInfoAgentBasic.faxNumber = this.data.faxnumberBas
      this.formLabelAlign1.bscUserInfoAgentBasic.http = this.data.httpBas
      this.formLabelAlign1.bscUserInfoAgentBasic.companytype = this.data.companytypeBas
      this.formLabelAlign1.bscUserInfoAgentBasic.founded = this.data.foundedBas
      this.formLabelAlign1.bscUserInfoAgentBasic.regmoney = this.data.regmoneyBas
      this.formLabelAlign1.bscUserInfoAgentBasic.legal = this.data.legalBas
      this.formLabelAlign1.bscUserInfoAgentBasic.introduce = this.data.introduceBas
      this.formLabelAlign1.bscUserInfoAgentBasic.business = this.data.businessBas
      this.formLabelAlign1.bscUserInfoAgentBasic.achievement = this.data.achievementBas
      this.formLabelAlign1.bscUserInfoAgentBasic.legalPhone = this.data.legalPhoneBas
      this.formLabelAlign1.bscUserInfoAgentBasic.brand = this.data.brandBas
      this.formLabelAlign1.bscUserInfoAgentBasic.personnelNum = this.data.personnelNumBas
      this.formLabelAlign1.bscUserInfoAgentBasic.resource = this.data.resourceBas
      this.formLabelAlign1.bscUserInfoAgentBasic.name1 = this.data.name1Bas
      this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber1 = this.data.phonenumber1Bas
      this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel = this.data.agentLevelBas
      this.formLabelAlign1.bscUserInfoAgentBasic.oneLevelAgent = this.data.oneLevelAgentBas
      this.formLabelAlign1.bscUserInfoAgentBasic.oneLevelAgentName = this.data.oneLevelAgentNameBas
      this.formLabelAlign1.bscUserInfoAgentBasic.contactMobilePhone = this.data.contactmobilephoneBas
      //this.formLabelAlign1.bscUserInfoAgentBasic.customerName1 = this.data.customername1Bas
      this.formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom = this.data.citystreetroomBas
      this.formLabelAlign1.bscUserInfoAgentBasic.streetRoom = this.data.streetroomBas
      this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber = this.data.phonenumberBas
      this.formLabelAlign1.bscUserInfoAgentBasic.postalCode = this.data.postalcodeBas
      this.formLabelAlign1.bscUserInfoAgentBasic.name1 = this.data.name1Bas
      this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber1 = this.data.phonenumber1Bas
      this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan = this.data.iszhidanBas
      this.formLabelAlign1.bscUserInfoAgentBasic.associatedCompanyName = this.data.associatedCompanyNameBas
      this.formLabelAlign1.bscUserInfoAgentBasic.associatedCompanyCode = this.data.associatedCompanyCodeBas
      this.formLabelAlign1.bscUserInfoAgentBasic.contractId = this.data.contractIdBas
      this.formLabelAlign1.bscUserInfoAgentSell.xkzEffectiveDate = this.data.xkzEffectiveDateSell
      this.formLabelAlign1.bscUserInfoAgentSell.yyzzEffectiveDate = this.data.yyzzEffectiveDateSell
      if (this.data.iszhidanBas == 1) {
        this.isZhiDan = true;
      }
      this.formLabelAlign1.bscUserInfoAgentBasic.isExpandAuthority  = this.data.isExpandAuthorityBas;
      if(this.data.isExpandAuthorityBas == 1){
        this.isExpandAuthority = true
        this.isShowByHw = true;
        //this.formLabelAlign1.bscUserInfoAgentBasic.isTrade = 1
      }else{
        this.isExpandAuthority = false
        this.isShowByHw = false;
        //this.formLabelAlign1.bscUserInfoAgentBasic.isTrade = 0
      }
      this.formLabelAlign1.bscUserInfoAgentBasic.isBlood = this.data.isBloodBas
      if (this.data.isBloodBas == 1) {
        this.isBlood = true;
      }else {
        this.isBlood = false;
      }
      this.formLabelAlign1.bscUserInfoAgentBank.vatCode = this.data.vatcodeBank
      this.formLabelAlign1.bscUserInfoAgentBank.bankBranchCode = this.data.bankbranchcodeBank
      this.formLabelAlign1.bscUserInfoAgentBank.bankName = this.data.banknameBank
      this.formLabelAlign1.bscUserInfoAgentBank.accountHolderName = this.data.accountholdernameBank
      if (this.data.scaleBas !== undefined) {
        // this.formLabelAlign1.bscUserInfoAgentSell.customerGroup1 = this.data.customergroup1Sell.toString()
        this.formLabelAlign1.bscUserInfoAgentSell.customerGroup1 = this.data.customergroup1Sell
      }
      this.formLabelAlign1.bscUserInfoAgentBasic.email = this.data.emailBas
      this.formLabelAlign1.bscUserInfoAgentCompany.mailreceiver = this.data.mailreceiverCom
      this.formLabelAlign1.bscUserInfoAgentCompany.receiverphone = this.data.receiverphoneCom
      this.formLabelAlign1.bscUserInfoAgentCompany.mailaddress = this.data.mailaddressCom
      this.formLabelAlign1.bscUserInfoAgentSell.auditMind1 = this.data.auditmind1Sell
      this.formLabelAlign1.bscUserInfoAgentSell.auditMind2 = this.data.auditmind2Sell
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup = this.data.customergroupSell
      this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = this.data.customerassigngroupSell
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup1 = this.data.customergroup1Sell
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup2 = this.data.customergroup2Sell
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3 = this.data.customergroup3Sell
      this.formLabelAlign1.bscUserInfoAgentSell.salesCity = this.data.salesCitySell
      this.formLabelAlign1.bscUserInfoAgentSell.salesRegion = this.data.salesregionSell
      //许可证号
      this.formLabelAlign1.bscUserInfoAgentSell.licenseNumber = this.data.licenseNumberSell
      this.formLabelAlign1.bscUserInfoAgentSell.haveThree6840Sell = this.data.haveThree6840Sell
      if(this.data.haveThree6840Sell == 1){
        this.haveThree6840 = true
      }
      this.formLabelAlign1.bscUserInfoAgentBasic.contactCity = this.data.contactcityBas
      this.formLabelAlign1.bscUserInfoAgentBasic.remark = this.data.remarkBas||''
      this.formLabelAlign1.bscUserInfoAgentBasic.appellation = this.data.appellationBas
      this.formLabelAlign1.bscUserInfoAgentBasic.country = this.data.countryBas
      this.formLabelAlign1.bscUserInfoAgentBasic.region = this.data.regionBas
      this.formLabelAlign1.bscUserInfoAgentBasic.companyCodeGeneral = this.data.companycodegeneralBas
      this.formLabelAlign1.bscUserInfoAgentBasic.companyCode = this.data.companycodeBas
      this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = this.data.goodsCategoryBas
      this.formLabelAlign1.bscUserInfoAgentBasic.taxCode = this.data.taxcodeBas
      this.formLabelAlign1.bscUserInfoAgentBasic.isFenxiao = this.data.isFenxiaoBas;
      this.formLabelAlign1.bscUserInfoAgentBasic.statusFenxiao = this.data.statusFenxiaoBas;
      this.formLabelAlign1.bscUserInfoAgentBasic.instidFenxiao = this.data.instidFenxiaoBas;
      this.formLabelAlign1.bscUserInfoAgentBasic.signingFenxiao = this.data.signingFenxiaoBas;
      this.formLabelAlign1.bscUserInfoAgentBank.bankCountry = this.data.bankcountryBank
      this.formLabelAlign1.bscUserInfoAgentSell.distributionChannel = this.data.distributionchannelSell
      this.formLabelAlign1.bscUserInfoAgentSell.salesGroup = this.data.salesgroupSell
      this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = this.data.currencycodeSell
      this.formLabelAlign1.bscUserInfoAgentSell.inEmail = this.data.inEmailSell
      this.formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup = this.data.accountdistributegroupSell
      this.formLabelAlign1.bscUserInfoAgentSell.have6840 = this.data.have6840Sell
      this.formLabelAlign1.bscUserInfoAgentSell.have6854 = this.data.have6854Sell
      this.formLabelAlign1.bscUserInfoAgentSell.have6858 = this.data.have6858Sell
      this.formLabelAlign1.bscUserInfoAgentSell.have1101 = this.data.have1101Sell
      this.formLabelAlign1.bscUserInfoAgentSell.have2214 = this.data.have2214Sell
      this.formLabelAlign1.bscUserInfoAgentSell.havepolicy2017= this.data.havepolicy2017Sell
      this.formLabelAlign1.bscUserInfoAgentSell.have2215 = this.data.have2215Sell
      this.formLabelAlign1.bscUserInfoAgentSell.have2216 = this.data.have2216Sell
      this.formLabelAlign1.bscUserInfoAgentSell.permit = this.data.permitSell

      this.formLabelAlign1.bscUserInfoAgentScore.staffing = this.data.staffingSco
      this.formLabelAlign1.bscUserInfoAgentScore.scale = this.data.scaleSco
      this.formLabelAlign1.bscUserInfoAgentScore.qualification = this.data.qualificationSco
      this.formLabelAlign1.bscUserInfoAgentScore.brandPower = this.data.brandPowerSco
      this.formLabelAlign1.bscUserInfoAgentScore.businessPower = this.data.businessPowerSco
      this.formLabelAlign1.bscUserInfoAgentScore.conclusion = this.data.conclusionSco
      this.formLabelAlign1.bscUserInfoAgentScore.daquConfirm = this.data.daquConfirmSco
      this.formLabelAlign1.bscUserInfoAgentScore.quyuConfirm = this.data.quyuConfirmSco
      this.formLabelAlign1.bscUserInfoAgentSell.invInformation = this.data.invInformation
      if (this.data.agentTypeBas == '3' || this.data.isExpandAuthorityBas == 1) {
        this.formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms = this.data.intcommercialtermsSell;
        this.formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms2 = this.data.intcommercialterms2Sell;
      }
      if (this.data.have6840Sell == 1) {
        this.have6840 = true;
      }
      if (this.data.have6854Sell == 1) {
        this.have6854 = true;
      }
      if (this.data.have6858Sell == 1) {
        this.have6858 = true;
      }
      if (this.data.have1101Sell == 1) {
        this.have1101 = true;
      }
      if (this.data.have2214Sell == 1) {
        this.have2214 = true;
      }
      if (this.data.have2215Sell == 1) {
        this.have2215 = true;
      }
      if (this.data.have2216Sell == 1) {
        this.have2216 = true;
      }
      if (this.data.havepolicy2017Sell == 1) {
        this.havepolicy2017 = true;
      }
      if(this.agentType == '3'){
        this.getLQs(s)
      }

      this.formLabelAlign1.bscUserInfoAgentSell.licenseNumber = this.data.licenseNumberSell
      let s = this.data.goodsCategoryBas;
      if(this.data.goodsCategoryBas != null && this.data.goodsCategoryBas != '' && typeof(this.data.goodsCategoryBas) != "undefined"){
        let s = this.data.goodsCategoryBas;
        if(this.$route.query.isFreezeData === '1'){

        }else {
          this.getLianquns(s)
          this.getLQs(s)
        }
      }
      if(this.data.customergroup3Sell != null && this.data.customergroup3Sell != '' && typeof(this.data.customergroup3Sell) != "undefined"){
        var s1 = this.data.customergroup3Sell
        var m  = s1.split(',');
        if(m.length<=0){
          this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3 = ''
        }else {
          this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3 = m
          this.getQudao(this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3)
          this.chflag--;
        }
      }
      if(this.data.salesCitySell != null && this.data.salesCitySell != '' && typeof(this.data.salesCitySell) != "undefined"){
        var s1 = this.data.salesCitySell
        var m  = s1.split(',');
        if(m.length<=0){
          this.formLabelAlign1.bscUserInfoAgentSell.salesCity = ''
        }else {
          this.formLabelAlign1.bscUserInfoAgentSell.salesCity = m
          this.getCity(this.formLabelAlign1.bscUserInfoAgentSell.salesCity)
          this.chflag--;
        }
      }
      this.agentUpdateFile();
      //判断是不是91码
      if(this.formLabelAlign1.bscUserInfoAgentBasic.usercode.startsWith("91")){
        this.is91 = true;
      }
      if(this.data.agentLevelBas == null || this.data.agentLevelBas == '' ){
        this.getAgentByContract(this.data.customername1Bas);
      }
      //获取合同信息
      if(this.agentType != 3){
        ss.contractService.getContractByUsercode(this.formLabelAlign1.bscUserInfoAgentBasic.usercode).then(rd => {
          if(rd.f){
            console.log("rd",rd);
            this.formLabelAlign1.contractList = rd.msg;
            if(this.formLabelAlign1.bscUserInfoAgentSell.salesCity == null || this.formLabelAlign1.bscUserInfoAgentSell.salesCity ==''){
              if(rd.msg[0].salesCity != null && rd.msg[0].salesCity != '' && typeof(rd.msg[0].salesCity) != "undefined"){
                var s1 = rd.msg[0].salesCity
                var m  = s1.split(',');
                if(m.length<=0){
                  this.formLabelAlign1.bscUserInfoAgentSell.salesCity = ''
                }else {
                  this.formLabelAlign1.bscUserInfoAgentSell.salesCity = m
                  this.getCity(this.formLabelAlign1.bscUserInfoAgentSell.salesCity)
                  this.chflag--;
                }
              }
            }
          }
        })
      }
      if(this.agentType != 3){
        this.getAreaCity();
      }
    },
    getLianquns(s){
      var m  = s.split(',');
      if(m.length<=0){
        this.lianqunList = []
      }else {
        this.lianqunList = m
      }
    },
    getLQs(s) {
      let that = this;
      agentCopyService.getLqSelectList().then(res =>{
        that.LQList = res
        console.log(res,"res11111111111111111111111111")
        //如果是外销
        if(this.agentType == '3'){
          //外销展示所有链群
          var LQcheckLists = []
          res.forEach((item, index) => {
            LQcheckLists.push(item.lianqun)
          })
          that.LQcheckList = LQcheckLists
          this.LQSelect()
        }else { //内销
          var m  = s.split(',');

          if(m.length<=0){
            that.LQcheckList = []

          }else {
            that.LQcheckList = [...new Set(m)];
            this.LQSelect()
          }
        }
      });
    },
    goBack() {
      this.$router.push({path: '/agent/agentCopy'})
    },
    insert(formName) {
      var flag = 0;
      //非海外经销商注册
      if (this.isShowMassage === true) {
        for (var i = 0; i < this.index.length; i++) {
          this.ind = this.index[i];
          var form = formName + this.ind;
          // console.log(form)
          this.$refs[form].validate((valid) => {
            if (valid) {

            } else {
              flag = flag + 1;
              return false;
            }
          });
        }
        //海外经销商注册
      } else {
        for (var i = 2; i < this.index.length; i++) {
          this.ind = this.index[i];
          var form = formName + this.ind;
          // console.log(form)
          this.$refs[form].validate((valid) => {
            if (valid) {

            } else {
              flag = flag + 1;
              return false;
            }
          });
        }
      }
      if (flag !== 0) {
        return false;
      }
      // this.loading = true;
      if (this.have2 === true && this.have3 === false) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 2;
      } else if (this.have2 === false && this.have3 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 3;
      } else if (this.have2 === true && this.have3 === true) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 5;
      } else if (this.have2 === false && this.have3 === false) {
        this.formLabelAlign1.bscUserInfoAgentSell.permit = 0;
      }
      if (this.agentType == '3') {
        if(!this.isExpandAuthority){
          this.formLabelAlign1.bscUserInfoAgentBasic.region = this.formLabelAlign1.bscUserInfoAgentBasic.country;
        } else {
          this.formLabelAlign1.bscUserInfoAgentBasic.region = this.formLabelAlign1.bscUserInfoAgentBasic.region;
        }
      } else {
        this.formLabelAlign1.bscUserInfoAgentBasic.region = this.formLabelAlign1.bscUserInfoAgentBasic.region;
      }
      this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber1 = this.formLabelAlign1.bscUserInfoAgentCompany.receiverphone;
      ss.SignService.insert(this.formLabelAlign1).then(response => {
        this.loading = false;
        if (response.f) {
          // this.loading = false;
          this.$message({
            type: "success",
            message: response.msg
          });
          if (this.flag === '1' || this.flag === '3' || this.flag === '4') {
            this.$router.push({path: '/agent/agentCopy'})
          } else {
            this.$router.push({path: '/login'})
          }
        } else {
          this.$message({
            type: "error",
            message: response.msg
          });
          this.loading = false;
        }
      })
    },
    go(index) {
      this.indx = index;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    beforeRemove(file) {
      if (file && file.status === "success") {
        return this.$confirm(`确定移除 ${ file.name }？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        });
      }
    },
    beforeUpload(file){
      const isFile = file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'application/pdf';
      const isLt5M = file.size / 1024 / 1024 < 5;
      console.log(isFile,file.type)

      if (!isFile) {
        this.$message.error('上传文件的格式只能是 JPG或PNG或PDF 格式!');
        return false;
      }
      if (!isLt5M) {
        this.$message.error('上传文件的大小不能超过 5M!');
        return false;
      }
    },
    toLogin() {
      this.$router.push({path: '/login'})
    },
    //公司代码改变回掉
    companyCodeChange(obj) {
      console.log("obj",this.formLabelAlign1.bscUserInfoAgentBasic.companyCode);
      //经销商签约公司增加1RK0,前台选择1RK0时内销经销商,默认带出9390,9370,外销默认带出,9390,6200,其他公司不做处理
      if (obj && obj.length > 0) {
        let bool = false;
        for (let item of obj) {
          if (item.code == '1RK0') {
            bool = true;
          }
        }
        if (bool) {
          let s = this.formLabelAlign1.bscUserInfoAgentBasic.companyCode;
          s = s.split(',');
          console.log("s",this.agentType);
          if (s && s.length > 0 && s[s.length - 1] == '1RK0') {
            if( s.findIndex(item => item == 9390) == -1){
              s.push("9390");
            }
            if(this.agentType == 1){ //内销判断9370
              if( s.findIndex(item => item == '0HL0') == -1){
                s.push("0HL0");
              }
            }
            if(this.agentType == 3){ //外销判断6200
              if( s.findIndex(item => item == '64W0') == -1){
                s.push("64W0");
              }
            }
            var codes = s.join(",");
            this.formLabelAlign1.bscUserInfoAgentBasic.companyCode = codes;
          }
        }
      }
      this.companyCodeNumFlag++;
    },
    showAgentList(value) {
      ss.UserService.selectAgentByName(value).then(rd=>{
        console.log(rd);
        this.oneAgentList = rd.msg;
      })
      this.isShowAllSelect = false
      this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = '';
      this.lianqunList = [];
    },
    changeAgent(value){
      console.log(value)
      this.formLabelAlign1.bscUserInfoAgentBasic.oneLevelAgentName = value.customerName
      this.formLabelAlign1.bscUserInfoAgentBasic.oneLevelAgent = value.usercode
      this.formLabelAlign1.bscUserInfoAgentSell.salesRegion = value.salesRegion
      this.formLabelAlign1.bscUserInfoAgentSell.salesGroup = value.salesGroup
      this.formLabelAlign1.bscUserInfoAgentSell.saleChannel = value.saleChannel
      this.formLabelAlign1.bscUserInfoAgentSell.distributionChannel = value.distributionChannel

      this.formLabelAlign1.bscUserInfoAgentSell.companyCode = value.companyCode
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3 = value.customerGroup3
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain = this.data.customerGroup3NotMainSell
      this.formLabelAlign1.bscUserInfoAgentSell.customerGroup2 = value.customerGroup2
      this.formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup = value.accountDistributeGroup
      this.formLabelAlign1.bscUserInfoAgentSell.salesCity = value.salesCitySell
      this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = value.goodsCategory
      this.formLabelAlign1.bscUserInfoAgentBasic.companyCode = value.companyCode
      if(value.goodsCategory == ''){
        this.lianqunList = []
      }

      if(value.customerGroup3 != null && value.customerGroup3 != ''){
        let s = value.customerGroup3
        var m  = s.split(',');
        if(m.length<=0){
          this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3 = ''
        }else {
          this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3 = m
        }
      }

      if(value.customerGroup3NotMain != null && value.customerGroup3NotMain != ''){
        let s = value.customerGroup3NotMain
        var m  = s.split(',');
        if(m.length<=0){
          this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain = ''
        }else {
          this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain = m
        }
      }
      this.showLianqun(value)
      this.chflag--;
      let s = value.goodsCategory
      if(s != null && s!='' && typeof(s) != "undefined"){
        this.getLianquns(s)
        this.getLQs(s)
      }
      this.chflag++;
    },
    showLianqun(value){
      this.chflag++;
      if(value.goodsCategory == null || value.goodsCategory == '' || typeof(value.goodsCategory)=="undefined"){
        this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = '';
        this.lianqunList = []
      }
      var lianqun = value.goodsCategory
      if(lianqun != null && lianqun != '' && typeof(lianqun)!="undefined"){

        if(lianqun.indexOf("X02") != -1 || lianqun.indexOf("X01") != -1
            ||lianqun.indexOf("X08") != -1 ||lianqun.indexOf("X09") != -1
            ||lianqun.indexOf("X10") != -1 ||lianqun.indexOf("X07") != -1
            ||lianqun.indexOf("X11") != -1){
          if( this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel == 1){
            this.ctLevel = '04'
          }
          if( this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel == 3){
            this.ctLevel = '04'
          }
          if( this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel == 2){
            this.ctLevel = '04'
          }
        }else {
          this.ctLevel = ''
        }
      }
    },
    changDealer(value){
      this.formLabelAlign1.beUpdate++;
      console.log(value.code,"value")
      if(value.code == 4 || value.code == 7 || value.code == 8){
        this.isZhiDan = true;
        this.chooseZhiDan();
      }else {
        this.isZhiDan = false;
        this.chooseZhiDan();
      }
    },
    lianqunOptions1111(value){
      this.formLabelAlign1.beUpdate++;
      this.chflag++;
      console.log(value)
    },

    getQudao(value){
      var jsonObj = value
      var jStr = '';
      for(var item in jsonObj){
        jStr += jsonObj[item]+",";
      }
      this.qudaos = jStr.substring(0, jStr.lastIndexOf(','))
      this.chflag++;
    },
    getCity(value){
      this.citys = value.join(",")
      console.log(this.citys);
      this.chflag++;
    },
    getQudaoL(value){
      var jsonObj = value
      var jStr = '';
      for(var item in jsonObj){
        jStr += jsonObj[item]+",";
      }
      return jStr.substring(0, jStr.lastIndexOf(','))
    },
    changeQudao(){
      this.formLabelAlign1.beUpdate++;
      this.chflag++;
      this.$forceUpdate();
    },
    getQudaoCt(qudaos){
      console.log("qudao",qudaos)
      this.qudaoListL1 =[];
      //获取所有渠道
      var jso = this.formLabelAlign1.ctList;
      for(var item in jso){
        var jsoElement = jso[item].channelList;
        for(var item in jsoElement){
          this.qudaoListL1.push(jsoElement[item])
        }
      }
      this.formLabelAlign1.beUpdate++;
      this.chflag++;
    },
    hasInclude(arr = [],item){
      return arr.includes(item)
    },
    hasIncludeField(arr = [],item){
      return arr.includes(item)
    },
    showAssociationAgent(value){
      console.log('value',value);
      agentCopyService.getOverseasAgent(value).then(rd=>{
        console.log(rd);
        this.associatedCompanyList = rd.obj;
      })
    },
    changeAssociationAgent(value){
      this.formLabelAlign1.bscUserInfoAgentBasic.associatedCompanyName = value.username;
      this.formLabelAlign1.bscUserInfoAgentBasic.associatedCompanyCode = value.usercode;
    },
    fileBack4(v) {
      console.log(v)
      this.formLabelAlign1.bscUserInfoAgentBasic.upload9 = v.length;
    },
    // 获取修改记录
    agentUpdateFile() {
      this.mf.userCode = this.formLabelAlign1.bscUserInfoAgentBasic.usercode;
      console.log("this.mf",this.mf);
      //更新到期时间
      agentCopyService.agentUpdateFile(this.mf).then(rd =>{
        console.log("agentUpdateFile",rd)
        this.fileList = rd.records
        this.mf.total = rd.total
      });
    },
    addCtList(){
      //判断是不是选择了领域
      for(var i=0;i<this.formLabelAlign1.ctList.length;i++){
        if(this.formLabelAlign1.ctList[i].field == null || this.formLabelAlign1.ctList[i].field == ''
            || this.formLabelAlign1.ctList[i].channelList == null || this.formLabelAlign1.ctList[i].channelList == ''
            || this.formLabelAlign1.ctList[i].level == null || this.formLabelAlign1.ctList[i].level == ''
        ){
          this.$msg.msge("请先完善后在新增!")
          return;
        }
      }
      this.formLabelAlign1.ctList.push({
        field:'',//领域
        channel:'',//渠道
        channelList:[],//渠道
        level:'',//等级
        num: null,
        area: null,
        lianqun:'',
        lianqunList:[],//链群
      })
      console.log(this.formLabelAlign1.ctList.length)
      this.fields = [];
      for(var i=0;i<this.formLabelAlign1.ctList.length;i++){
        if(this.formLabelAlign1.ctList[i].field != null && this.formLabelAlign1.ctList[i].field != ''){
          this.fields.push(this.formLabelAlign1.ctList[i].field);
        }
      }
      this.chflag++;
    },
    deleteCtList() {
      if(this.formLabelAlign1.ctList.length != 1){
        this.formLabelAlign1.ctList.splice(this.formLabelAlign1.ctList.length-1, 1)
        this.fields = [];
        for(var i=0;i<this.formLabelAlign1.ctList.length;i++){
          console.log(this.formLabelAlign1.ctList[i].field)
          if(this.formLabelAlign1.ctList[i].field != null && this.formLabelAlign1.ctList[i].field != ''){
            this.fields.push(this.formLabelAlign1.ctList[i].field);
          }
        }
      }
      this.chflag++;
    },
    //是否开通血站 国内和上海特有
    chooseIsBlood(){
      this.formLabelAlign1.beUpdate++;
      if (this.isBlood) {
        this.formLabelAlign1.bscUserInfoAgentBasic.isBlood = 1;
        console.log("开通血站")
      } else {
        this.formLabelAlign1.bscUserInfoAgentBasic.isBlood = 0;
        console.log("暂不开通血站")
      }
    },

    // 查询链群list
    getLqList() {
      agentCopyService.getLqSelectList().then(res =>{

        this.LQList = res
        console.log(this.LQList,"获取获取获取")
      });
    },
    LQSelect() {
      // this.checkLQAfterList = [];
      let map = new Map();
      console.log(this.LQList,'有这个数组吗');
      for (let item of this.LQList) {
        if (!map.has(item.lianqun)) {
          map.set(item.lianqun, item);
        };
      };
      console.log(this.LQcheckList,"这个是选中的链群",map,[...map.values()])
      this.checkLQAfterList = [...map.values()].filter(item => this.LQcheckList.includes(item.lianqun))
      // // 取消勾选项清空输入值
      // let otherArr = [];
      // for (let i = 0; i < this.LQList.length; i++) {
      //   let isExist = false;
      //   for (let j = 0; j < this.LQcheckList.length; j++) {
      //     if (this.LQList[i].lianqun === this.LQcheckList[j]) {
      //       isExist = true;
      //       break;
      //     }
      //   }
      //   if (!isExist) {
      //     otherArr.push(this.LQList[i]);
      //   }
      // }
      if(this.addForm) {
        otherArr.forEach((el,index)=>{
          this.addForm[el.companyCode] = '';
          this.addForm[el.companyCode+ 'Channel'] = ''
        })
      }
      this.chflag++;
      console.log(this.chflag,"this.chflagthis.chflag")
      // this.$forceUpdate();
    },
    getAreaCity(){
      let areas = this.formLabelAlign1.bscUserInfoAgentSell.salesRegion.split(",");
      console.log(areas, "areasareasareasareasareasareas")
      let ss1 = [];
      let promises = []; // 创建一个存储异步操作的Promise数组
      for (var i = 0; i < areas.length; i++) {
        let promise = ss.Dictservice.getDictByCateCode("YlSalesArea_chanpin", areas[i])
            .then(response => {
              ss1.push(response.refid);
            });
        promises.push(promise); // 将每个异步操作的Promise添加到数组中
      }

      Promise.all(promises) // 等待所有异步操作完成
          .then(() => {
            var s2 = ss1.join(",");
            ss.UserService.getCityByArea(s2).then(rd => {
              this.salesCity = rd.msg;
            });
          });
    },
    changeAreaLevel(query){
      console.log(query);
      console.log(this.formLabelAlign1.bscUserInfoAgentSell.salesRegion);
      let salesRegions = this.formLabelAlign1.bscUserInfoAgentSell.salesRegion.split(",");
      console.log(this.formLabelAlign1.bscUserInfoAgentSell.salesRegion.indexOf(query.code) == -1);
      if(this.formLabelAlign1.bscUserInfoAgentSell.salesRegion.indexOf(query.code) == -1){
        salesRegions.push(query.code);
        console.log(salesRegions);
        this.formLabelAlign1.bscUserInfoAgentSell.salesRegion = salesRegions.join(",");
        this.getAreaCity();
      }
    },
    //根据经销商名称获取合同号
    getAgentByContract(query) {
      ss.SignService.getAgentByContract(query).then(response => {
        console.log("response",response);
        this.formLabelAlign1.bscUserInfoAgentBasic.contractId = response.msg.id;
        //根据合同类型关联经销商类型
        //经销商框架合同类型 一级经销商、分销商、专营商、高能合伙人、直单用户、异业联盟、战略合作对应1234567
        //地市直营商 9
        //经销商等级 一级经销商1 分销商2 专营商3 直单4
        if(response.msg.contractAgent == 1){
          this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel = '1';
          this.data.iszhidanBas = ''
          this.priceLevel = '01';
          //根据签约渠道
        }else if(response.msg.contractAgent == 3 || response.msg.contractAgent == 4){
          this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel = '3';
          this.data.iszhidanBas = ''
          this.priceLevel = '03';
        } else if(response.msg.contractAgent == 2 || response.msg.contractAgent == 9 ){
          this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel = '2';
          this.data.iszhidanBas = ''
          this.priceLevel = '02';
        }else if(response.msg.contractAgent == 5 || response.msg.contractAgent == 6 ||response.msg.contractAgent == 7){
          this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel = '4';
          this.isZhiDan = true;
          this.data.iszhidanBas = '1'
          this.priceLevel = '04';
          this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan = 1;
        }else if (response.msg.contractAgent == 8){
          this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel = '5';
          this.data.iszhidanBas = ''
          this.isZhiDan = false;
          this.formLabelAlign1.bscUserInfoAgentBasic.oneLevelAgent = response.msg.oneLevelAgent;
          this.formLabelAlign1.bscUserInfoAgentBasic.oneLevelAgentName = response.msg.oneLevelAgentName;
          this.priceLevel = '03';
          this.formLabelAlign1.ctList =  [{
            field:'',//领域
            channelList:[],//渠道
            channel:'',//渠道
            level:this.priceLevel,//等级
            num: null,
            lianqun:'',
            lianqunList:[],//链群
            showLq : false,
          }];
        }else if(response.msg.contractAgent == 9){
          this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel = '6';
          this.data.iszhidanBas = ''
        }
        if(response.msg.map['lianqunsCt'] != null){
          this.isCt = true;
          this.lianqunListCt.push("ct");
          if(response.msg.map['qudaosL1'] != null && response.msg.map['qudaosL2']){
            this.formLabelAlign1.ctList =  [{
              field:'L1',//领域
              channelList:response.msg.map['qudaosL1'],//渠道
              channel:'',//渠道
              level:this.priceLevel,//等级
              num: null,
              lianqun:'',
              lianqunList:response.msg.map['lianqunsCt'],//链群
              showLq : true,
            },
              {
                field:'L2',//领域
                channelList:response.msg.map['qudaosL2'],//渠道
                channel:'',//渠道
                level:this.priceLevel,//等级
                num: null,
                lianqun:'',
                lianqunList:response.msg.map['lianqunsCt'],//链群
                showLq : true,
              }
            ];
          }else if(response.msg.map['qudaosL2'] != null){
            this.formLabelAlign1.ctList =  [{
              field:'L2',//领域
              channelList:response.msg.map['qudaosL2'],//渠道
              channel:'',//渠道
              level:this.priceLevel,//等级
              num: null,
              lianqun:'',
              lianqunList:response.msg.map['lianqunsCt'],//链群
              showLq : true,
            }];
          }else if(response.msg.map['qudaosL1'] != null){
            this.formLabelAlign1.ctList =  [{
              field:'L1',//领域
              channelList:response.msg.map['qudaosL1'],//渠道
              channel:'',//渠道
              level:this.priceLevel,//等级
              num: null,
              lianqun:'',
              lianqunList:response.msg.map['lianqunsCt'],//链群
              showLq : true,
            }];
          }
        }
        this.formLabelAlign1.bscUserInfoAgentBasic.contractType = response.msg.contractAgent;
      })
    },
    //添加新的产业
    addIndustry(){
      const newIndustry = {
        industryName: '',
      }
      this.formLabelAlign1.ctList.push(newIndustry)
    },
    //删除产业
    deleteIndustry(index){
      this.formLabelAlign1.ctList.splice(index, 1);
    },
    handleTab(e){
      this.formLabelAlign1.gsValue = e.label

      console.log(e.label);

      if(e.label!=='总部'){
        // this.getLianqunTickct([e.name])
        this.gnsc = false;
        // this.checkLQAfterList = [];
        let map = new Map();
        for (let item of this.LQList) {
          if (!map.has(item.lianqun)) {
            map.set(item.lianqun, item);
          }
        }
        this.LQcheckList = [e.name]
        this.checkLQAfterList = [...map.values()].filter(item => this.LQcheckList.includes(item.lianqun))
        // // 取消勾选项清空输入值
        // let otherArr = [];
        // for (let i = 0; i < this.LQList.length; i++) {
        //   let isExist = false;
        //   for (let j = 0; j < this.LQcheckList.length; j++) {
        //     if (this.LQList[i].lianqun === this.LQcheckList[j]) {
        //       isExist = true;
        //       break;
        //     }
        //   }
        //   if (!isExist) {
        //     otherArr.push(this.LQList[i]);
        //   }
        // }
        // if(this.addForm) {
        //   otherArr.forEach((el,index)=>{
        //     this.addForm[el.companyCode] = '';
        //     this.addForm[el.companyCode+ 'Channel'] = ''
        //   })
        // }
        this.chflag++;
      }else {
        this.gnsc = true;
        console.log( this.gnsc);
        this.LQSelect()
      }
      console.log( this.gnsc);
    }
  },
  mounted() {
    this.flag = this.$route.query.index;
    console.log(this.flag, 'flag');
    if (this.flag === '2') {
      this.uploadflag = false;
      this.delflag = false;
      this.data = this.$route.query;
      this.rules = {};
      this.checkDetail();
    } else if (this.flag === '3') {
      this.uploadflag = false;
      this.delflag = false;
      this.data = this.$route.query;
      this.rules = {};
      this.checkDetail();
    }
    let str  = this.formLabelAlign1.bscUserInfoAgentBasic.companyCode;
    if(str&&str.split(',').indexOf('9390') >= 0){
      this.isShowAllSelect = true;//判断是否展示全部群连并checkbox
    }

  }
}
</script>
<style scoped>
.imgBox {
  margin: 20px;
}

.bannerBox {
  width: 100%;
  margin: 0 auto;
}

.whiteBox {
  padding: 0.22rem 0.26rem;
  background-color: #ffffff;
}

.titles {
  font-size: 0.16rem;
  color: #0e75e9;
  position: relative;
  padding-left: 9px;
  border-left: 0.05rem solid #0e75e9;
  font-weight: bold;
}
</style>
<style>
.weekplandetail12 .h-formbLine .el-form-item.HAVES-2 .el-form-item__label {
  width: 10%;
}

.weekplandetail12 .h-formbLine .el-form-item.HAVES-2 .el-form-item__content {
  width: 100%;
}

.weekplandetail12 .h-formbLine .h-elformWrap-1 .el-form-item__content {
  width: 70%;
}

.weekplandetail12 .h-formbLine .h-elformWrap-1 .el-form-item__label {
  width: 22.5%;
}

.h-formbLine .newBox .el-form-item__content {
  width: 77.5%;
}

.h-formbLine .newBox .el-form-item__label {
  width: 9.7%;
  text-align: right;
}

.passfollow {
  position: absolute;
  right: 0;
  bottom: 0.3rem;
  background-color: #2785e7;
  color: white;
}

.zhanghu .h-formbLine .el-form-item__label {
  width: 42%;
}

.signsign .h-formbLine .el-form-item__label {
  width: 40%;
}

.zhanghu .h-formbLine .el-form-item__content,
.signsign .h-formbLine .el-form-item__content {
  width: 52%;
}

.zhanghu .h-formbLine .h-elformWrap-2,
.signsign .h-formbLine .h-elformWrap-2 {
  width: 25%;
  padding-right:0
}

.weekplandetail12 .h-formbLine .el-form-item__label {
  width: 48%;
}

.weekplandetail12 .h-formbLine .el-form-item__content {
  width: 52%;
}

.bannerBox .el-form-item__content {
  width: 85%;
}

.bannerBox .el-input__inner {
  border: none;
  border-bottom: 1px solid #DCDFE6;
}

.width .h-formbLine .el-form-item__content .el-select {
  width: 100%;
}

.signsign .h-formbLine .h-elformWrap-1 .el-form-item__label {
  width: 0%;
}

.signsign .h-formbLine .h-elformWrap-1 .el-form-item__content {
  width: 100%;
}

.gccolor .el-form-item__label {
  color: rgb(255, 36, 36);
}
.w-elformWrap {
  width: 100% !important;
}
.w-elformWrap .el-form-item__label {
  width: 10% !important;
}
.w-elformWrap .el-form-item__content {
  width: 89% !important;
}

.Yangbiao .h-elformWrap-3 {
  width: 85% !important;
  padding-right: 0.5rem
}
.Yangbiao .h-elformWrap-3 .el-form-item__label {
  width: 12%;
  text-align: right;
}

.qudoa{
  font-size: 0.18rem;
  color: #868686;
  line-height: 0.28rem;
  width: 0.5rem;
}
.foundation-box{
  font-size: 0.18rem;
  color: #868686;
  line-height: 0.28rem;
}


</style>
<style scoped>
.h-elformWrap-5{
  width: 39%!important;
  margin-left: 10%
}
/deep/.h-elformWrap-5 .el-form-item__content {
  width: 90%!important;
}
::v-deep .weekplandetail12 .h-formbLine .h-elformWrap-2 {
  width: 33% !important;
}
::v-deep.weekplandetail12 .h-formbLine .el-form-item__label {
  width: 48%;
}

::v-deep.weekplandetail12 .h-formbLine .el-form-item__content {
  width: 50%;
}


.collapseTitle {
  font-size: 0.16rem;
  font-weight: bold;
  line-height: 1.11;
  padding-left: 10px;
  border-left: 0.05rem solid #0e75e9;
}
.hl-form-item-flex .el-form-item{
  display: flex;
}
::v-deep .el-input__inner {
  border-radius: 0;
  border: none;
  border-bottom: 1px solid #dcdfe6;
}
::v-deep .el-textarea__inner{
  border-radius: 0;
  border: none;
  border-bottom: 1px solid #dcdfe6;
}
::v-deep.el-tabs--border-card  {
  border:none;
  box-shadow: none;
}
::v-deep .el-tabs--border-card>.el-tabs__header{
  border: 1px solid #E4E7ED;
}

</style>
